export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, 'ociDropdowns', {value: this});
  },
  ociPerPageOptions: [12, 24, 48, 96],
  ociSalutation: [
    {id: null, name: null},
    {id: 'Mr', name: 'Mr.'},
    {id: 'Miss', name: 'Miss.'},
    {id: 'Mrs', name: 'Mrs'},
    {id: 'Dr', name: 'Dr.'},
  ],
  ociLostLeadReactivatedReasons: [
    {id: 'Rate Drop', name: 'Rate Drop'},
    {id: 'Promotion', name: 'Promotion'},
    {id: 'Changed Mind', name: 'Changed Mind'},
    {id: 'Better Suited Product', name: 'Better Suited Product'},
    {id: 'Other', name: 'Other'},
  ],
  ociActivityQuestions:[
    {id: 'eligibility', name: 'Eligibility'},
    {id: 'product', name: 'Product'},
    {id: 'oci', name: 'OCI'},
    {id: 'project', name: 'Project'},
    {id: 'Other', name: 'Other'},
  ],
  ociLostLeadReasons: [
    {id: 'Credit Score', name: 'Credit Score'},
    {id: 'Down Payment', name: 'Down Payment'},
    {id: 'Foreign', name: 'Foreign'},
    {id: 'Rate', name: 'Rate'},
    {id: 'Micro-unit', name: 'Micro-unit'},
    {id: 'Terms & Conditions', name: 'Terms & Conditions'},
    {id: 'Multi-doors', name: 'Multi-doors'},
    {id: 'OCI Brand Recognition', name: 'OCI Brand Recognition'},
    {id: 'All Cash Condo Purchaser', name: 'All Cash Condo Purchaser'},
    {id: 'Interim Occupancy Ending', name: 'Interim Occupancy Ending'},
    {id: 'Client Not Interested', name: 'Client Not Interested'},
    {id: 'No Response Contacted Multiple Times', name: 'No Response Contacted Multiple Times'},
    {id: 'Bad Contact Info', name: 'Bad Contact Info'},
    {id: 'Unsubscribed', name: 'Unsubscribed'},
    {id: 'Other', name: 'Other'}

  ],
  // don't use ociProjects.. go to the DB for this as the list will change frequently
  ociProjects:[
    {id: "", name: ""},
    {id: "Eau Du Soleil", name: "Eau Du Soleil"},
    {id: "Empire", name: "Empire"},
    {id: "Masey", name: "Masey"},
  ],
  ociResponseType:[
    {id: 'Accepted', name: 'Approved'},
    {id: 'Declined', name: 'Declined'},
  ],
  ociConsentType:[
    {id: 0, name: ''},
    {id: 6, name: 'override'},
    {id: 5, name: 'submitted form'},
  ],
  ociCampaignType:[
    {id: 'wealthsaver', name: 'wealth saver'},
    {id: 'nps', name: 'nps'},
    {id: 'preauth', name: 'pre-auth'},
  ],
  ociPhoneTypes:[
    {id: '', name: ''},
    {id: 'cell', name: 'cell'},
    {id: 'work', name: 'work'},

    {id: 'home', name: 'home'},
  ],
  ociEmailTypes:[
    {id: '', name: ''},
    {id: 'personal', name: 'personal'},
    {id: 'work', name: 'work'},
  ],
  ociPhonePrimary:[
    {id: null, name: ""},
    {id: true, name: "Yes"},
    {id: false, name: "No"},
  ],
  ociEmailPrimary:[
    {id: null, name: ""},
    {id: true, name: "Yes"},
    {id: false, name: "No"},
  ],

  ociApplicantStatus: [
    {id: 'prospect', name: 'Prospect'},
    {id: 'awareness', name: 'Awareness'},
    {id: 'exploration', name: 'Exploration'},
    {id: 'approval', name: 'Approval'},
    {id: 'funding', name: 'Funding'},
    {id: 'oneClosed', name: 'OneClosed'},
    {id: 'lostLead', name: 'Lost Lead'}
  ],
  ociLenderApplicantStatus: [
    {id: 'exploration', name: 'Exploration'},
    {id: 'approval', name: 'Approval'},
    {id: 'funding', name: 'Funding'},
    {id: 'oneClosed', name: 'OneClosed'}
  ],
  ociDealStatus: [
    {id: 'prospect', name: 'Prospect'},
    {id: 'purchaserApp', name: 'Purchaser App'},
    {id: 'mtgAppEntry', name: 'Mtg App Entry'},
    {id: 'conditions', name: 'Conditions'},
    {id: 'readyToSubmit', name: 'Ready To Submit'},
    {id: 'submittedToLender', name: 'Submitted to Lender'},
    {id: 'lenderApproved', name: 'Lender Approved'},
    {id: 'lenderDeclined', name: 'Lender Declined'},
    {id: 'accepted', name: 'Accepted'},
    {id: 'declined', name: 'Declined'},
    {id: 'dealComplete', name: 'Deal Complete'},
    {id: 'oneClosed', name: 'OneClosed'},
    {id: 'invoiced', name: 'Invoiced'},
    {id: 'paid', name: 'Paid'},
    {id: 'lostLead', name: 'Lost Lead'}
  ],
  ociLenderDealStatus: [
    {id: 'conditions', name: 'Conditions'},
    {id: 'submittedToLender', name: 'Received from Broker'},
    {id: 'lenderApproved', name: 'Approved'},
    {id: 'lenderDeclined', name: 'Declined'},
    {id: 'accepted', name: 'Purchaser Accepted'},
    {id: 'declined', name: 'Purchaser Declined'},
    {id: 'dealComplete', name: 'Deal Complete'},
    {id: 'oneClosed', name: 'OneClosed'},
    {id: 'invoiced', name: 'Invoiced'},
    {id: 'paid', name: 'Paid'},
  ],
  ociProjectStatus: [
    {id: 'new', name: 'New'},
    {id: 'error', name: 'Error'},
    {id: 'uploaded', name: 'Uploaded'},
    {id: 'campaign', name: 'Campaign'},
    {id: 'funded', name: 'Funded'},
    {id: 'suspended', name: 'Suspended'},
    {id: 'uploading', name: 'Uploading'},
    {id: 'inactive', name: 'Inactive'}
  ],
  ociLanguagePreference: [
    {id: '', name: ''},
    {id: 'english', name: 'English'},
    {id: 'french', name: 'French'}
  ],
  ociToBeSold: [
    {id: null, name: ''},
    {id: true, name: 'Yes'},
    {id: false, name: 'No'}
  ],
  ociApplicantType: [
    {id: 'applicant', name: 'Applicant'},
    {id: 'coApplicant', name: 'Co-applicant'},
    {id: 'guarantor', name: 'Guarantor'},

  ],
  ociAddNewApplicantType: [
    {id: null, name: null},
    {id: 'coApplicant', name: 'Co-applicant'},
    {id: 'guarantor', name: 'Guarantor'},
  ],
  ociRelationshipToPrimaryApplicant: [
    {id: null, name: ''},
    {id: 'Spouse', name: 'Spouse'},
    {id: 'Common Law', name: 'Common Law'},
    {id: 'Related Family Member', name: 'Related Family Member'},
    {id: 'Parent', name: 'Parent'},
    {id: 'Sibling', name: 'Sibling'},
    {id: 'Child', name: 'Child'},
    {id: 'Grandchild', name: 'Grandchild'},
    {id: 'Grandparent', name: 'Grandparent'},
    {id: 'Other', name: 'Other'}
  ],
  ociDwellingType: [
    {id: '', name: ''},
    {id: 'Condo', name: 'Condo'},
    {id: 'Townhome(Row)', name: 'Townhome(Row)'},
  ],
  ociPropertyType: [
    {id: '', name: ''},
    {id: 'Detached', name: 'Detached'},
    {id: 'Semi - Detached', name: 'Semi - Detached'},
    {id: 'Duplex - Detached', name: 'Duplex - Detached'},
    {id: 'Apartment Low Rise', name: 'Apartment Low Rise'},
    {id: 'Apartment High Rise', name: 'Apartment High Rise'},
    {id: 'Mobile', name: 'Mobile'},
    {id: 'Tri Plex - Detached', name: 'Tri Plex - Detached'},
    {id: 'Tri Plex - Semi-Detached', name: 'Tri Plex - Semi-Detached'},
    {id: 'Stacked', name: 'Stacked'},
    {id: 'Modular Home - Detached', name: 'Modular Home - Detached'},
    {id: 'Modular Home - Semi-Detached', name: 'Modular Home - Semi-Detached'},
    {id: 'Four Plex - Detached', name: 'Four Plex - Detached'},
    {id: 'Four Plex - Semi-Detached', name: 'Four Plex - Semi-Detached'},
    {id: 'Condo', name: 'Condo'},
    {id: 'Plot', name: 'Plot'},
    {id: 'Townhome(Row)', name: 'Townhome(Row)'},
  ],
  ociConstructionType: [
    {id: '', name: ''},
    {id: 'new', name: 'New'},
    {id: 'existing', name: 'Existing'},
  ],
  ociUnitType: [
    {id: '', name: ''},
    {id: '1BDRM', name: '1BDRM'},
    {id: '2BDRM', name: '2BDRM'},
    {id: '3BDRM', name: '3BDRM'},
    {id: 'studio', name: 'studio'},
  ],
  ociWaterType: [
    {id: '', name: ''},
    {id: 'municipal', name: 'Municipal'},
    {id: 'well', name: 'Well'},
  ],
  ociSewageType: [
    {id: '', name: ''},
    {id: 'municipal', name: 'Municipal'},
    {id: 'well', name: 'Well'},
  ],
  ociGarageType: [
    {id: '', name: ''},
    {id: 'attached', name: 'Attached'},
    {id: 'detached', name: 'Detached'},
  ],
  ociGarageSize: [
    {id: '', name: ''},
    {id: 'N/A', name: 'N/A'},
    {id: 'single', name: 'single'},
    {id: 'double', name: 'double'},
    {id: 'triple', name: 'triple'},
  ],
  ociRepaymentType: [
    {id: '', name: ''},
    {id: 'principal + interest', name: 'Principal + Interest'},
    {id: 'interest only', name: 'Interest Only'},
  ],
  ociLoanType: [
    {id: '', name: ''},
    {id: 'mortgage', name: 'Mortgage'},
    {id: 'loc', name: 'LOC'},
  ],
  ociHeatingType: [
    {id: '', name: ''},
    {id: 'Electric Baseboard', name: 'Electric Baseboard'},
    {id: 'Forced Air/Gas/Oil/Electric', name: 'Forced Air/Gas/Oil/Electric'},
    {id: 'Hot Water Heating', name: 'Hot Water Heating'},
    {id: 'Other', name: 'Other'},
  ],

  ociDwellingStyle: [
    {id: '', name: ''},
    {id: 'One storey', name: 'One storey'},
    {id: 'Bi-level', name: 'Bi-level'},
    {id: 'Two storey', name: 'Two storey'},
    {id: 'Split level', name: 'Split level'},
    {id: 'Story and a half', name: 'Story and a half'},
    {id: 'Three storey', name: 'Three storey'},
    {id: 'High Rise', name: 'High Rise'}

  ],
  ociOccupancy: [
    {id: '', name: ''},
    {id: 'Owner Occupied', name: 'Owner Occupied'},
    {id: 'Owner Occupied & Rental', name: 'Owner Occupied & Rental'},
    {id: 'Rental', name: 'Rental'},
    {id: 'Second Home', name: 'Second Home'}
  ],
  ociDirection: [
    {id: '', name: ''},
    {id: 'N', name: 'N'},
    {id: 'S', name: 'S'},
    {id: 'W', name: 'W'},
    {id: 'E', name: 'E'},
    {id: 'NW', name: 'NW'},
    {id: 'SW', name: 'SW'},
    {id: 'NE', name: 'NE'},
    {id: 'NW', name: 'NW'},
  ],
  ociStreetType: [
    {id: '', name: ''},
    {id: 'ABBEY', name: 'ABBEY'},
    {id: 'ACRES', name: 'ACRES'},
    {id: 'ALLEE', name: 'ALLEE'},
    {id: 'ALLEY', name: 'ALLEY'},
    {id: 'AUT', name: 'AUT'},
    {id: 'AV', name: 'AV'},
    {id: 'AVE', name: 'AVE'},
    {id: 'BAY', name: 'BAY'},
    {id: 'BEACH', name: 'BEACH'},
    {id: 'BEND', name: 'BEND'},
    {id: 'BLVD', name: 'BLVD'},
    {id: 'BOUL', name: 'BOUL'},
    {id: 'BOURNE', name: 'BOURNE'},
    {id: 'BYPASS', name: 'BYPASS'},
    {id: 'BYWAY', name: 'BYWAY'},
    {id: 'C', name: 'C'},
    {id: 'CAMPUS', name: 'CAMPUS'},
    {id: 'CAPE', name: 'CAPE'},
    {id: 'CAR', name: 'CAR'},
    {id: 'CARREF', name: 'CARREF'},
    {id: 'CDS', name: 'CDS'},
    {id: 'CERCLE', name: 'CERCLE'},
    {id: 'CH', name: 'CH'},
    {id: 'CHASE', name: 'CHASE'},
    {id: 'CIR', name: 'CIR'},
    {id: 'CIRCT', name: 'CIRCT'},
    {id: 'CLOSE', name: 'CLOSE'},
    {id: 'COMMON', name: 'COMMON'},
    {id: 'CONC', name: 'CONC'},
    {id: 'COTE', name: 'COTE'},
    {id: 'COUR', name: 'COUR'},
    {id: 'COVE', name: 'COVE'},
    {id: 'CRES', name: 'CRES'},
    {id: 'CRNRS', name: 'CRNRS'},
    {id: 'CROIS', name: 'CROIS'},
    {id: 'CROSS', name: 'CROSS'},
    {id: 'CRT', name: 'CRT'},
    {id: 'CTR', name: 'CTR'},
    {id: 'DALE', name: 'DALE'},
    {id: 'DELL', name: 'DELL'},
    {id: 'DIVERS', name: 'DIVERS'},
    {id: 'DOWNS', name: 'DOWNS'},
    {id: 'DR', name: 'DR'},
    {id: 'ECH', name: 'ECH'},
    {id: 'END', name: 'END'},
    {id: 'ESPL', name: 'ESPL'},
    {id: 'ESTATE', name: 'ESTATE'},
    {id: 'EXPY', name: 'EXPY'},
    {id: 'EXTEN', name: 'EXTEN'},
    {id: 'FARM', name: 'FARM'},
    {id: 'FIELD', name: 'FIELD'},
    {id: 'FOREST', name: 'FOREST'},
    {id: 'FRONT', name: 'FRONT'},
    {id: 'FWY', name: 'FWY'},
    {id: 'GATE', name: 'GATE'},
    {id: 'GDNS', name: 'GDNS'},
    {id: 'GLADE', name: 'GLADE'},
    {id: 'GLEN', name: 'GLEN'},
    {id: 'GREEN', name: 'GREEN'},
    {id: 'GRNDS', name: 'GRNDS'},
    {id: 'GROVE', name: 'GROVE'},
    {id: 'HARBR', name: 'HARBR'},
    {id: 'HGLNDS', name: 'HGLNDS'},
    {id: 'HILL', name: 'HILL'},
    {id: 'HOLLOW', name: 'HOLLOW'},
    {id: 'HTS', name: 'HTS'},
    {id: 'HWY', name: 'HWY'},
    {id: 'ILE', name: 'ILE'},
    {id: 'IMP', name: 'IMP'},
    {id: 'ISLAND', name: 'ISLAND'},
    {id: 'KEY', name: 'KEY'},
    {id: 'KNOLL', name: 'KNOLL'},
    {id: 'LANDNG', name: 'LANDNG'},
    {id: 'LANE', name: 'LANE'},
    {id: 'LINE', name: 'LINE'},
    {id: 'LINK', name: 'LINK'},
    {id: 'LKOUT', name: 'LKOUT'},
    {id: 'LMTS', name: 'LMTS'},
    {id: 'LOOP', name: 'LOOP'},
    {id: 'MALL', name: 'MALL'},
    {id: 'MANOR', name: 'MANOR'},
    {id: 'MAZE', name: 'MAZE'},
    {id: 'MEADOW', name: 'MEADOW'},
    {id: 'MEWS', name: 'MEWS'},
    {id: 'MONTEE', name: 'MONTEE'},
    {id: 'MOOR', name: 'MOOR'},
    {id: 'MOUNT', name: 'MOUNT'},
    {id: 'MTN', name: 'MTN'},
    {id: 'ORCH', name: 'ORCH'},
    {id: 'PARADE', name: 'PARADE'},
    {id: 'PARC', name: 'PARC'},
    {id: 'PASS', name: 'PASS'},
    {id: 'PATH', name: 'PATH'},
    {id: 'PINES', name: 'PINES'},
    {id: 'PK', name: 'PK'},
    {id: 'PKY', name: 'PKY'},
    {id: 'PL', name: 'PL'},
    {id: 'PLACE', name: 'PLACE'},
    {id: 'PLAT', name: 'PLAT'},
    {id: 'PLAZA', name: 'PLAZA'},
    {id: 'PORT', name: 'PORT'},
    {id: 'PROM', name: 'PROM'},
    {id: 'PT', name: 'PT'},
    {id: 'PTWAY', name: 'PTWAY'},
    {id: 'PVT', name: 'PVT'},
    {id: 'QUAY', name: 'QUAY'},
    {id: 'RANG', name: 'RANG'},
    {id: 'RD', name: 'RD'},
    {id: 'RDPT', name: 'RDPT'},
    {id: 'RG', name: 'RG'},
    {id: 'RIDGE', name: 'RIDGE'},
    {id: 'RISE', name: 'RISE'},
    {id: 'RLE', name: 'RLE'},
    {id: 'ROW', name: 'ROW'},
    {id: 'RTE', name: 'RTE'},
    {id: 'RUE', name: 'RUE'},
    {id: 'RUN', name: 'RUN'},
    {id: 'SENT', name: 'SENT'},
    {id: 'SQ', name: 'SQ'},
    {id: 'ST', name: 'ST'},
    {id: 'SUBDIV', name: 'SUBDIV'},
    {id: 'TERR', name: 'TERR'},
    {id: 'THICK', name: 'THICK'},
    {id: 'TLINE', name: 'TLINE'},
    {id: 'TOWERS', name: 'TOWERS'},
    {id: 'TRAIL', name: 'TRAIL'},
    {id: 'TRNABI', name: 'TRNABT'},
    {id: 'TSSE', name: 'TSSE'},
    {id: 'VALE', name: 'VALE'},
    {id: 'VIA', name: 'VIA'},
    {id: 'VIEW', name: 'VIEW'},
    {id: 'VILLGE', name: 'VILLGE'},
    {id: 'VISTA', name: 'VISTA'},
    {id: 'VOIE', name: 'VOIE'},
    {id: 'WALK', name: 'WALK'},
    {id: 'WAY', name: 'WAY'},
    {id: 'WHARF', name: 'WHARF'},
    {id: 'WOOD', name: 'WOOD'},
    {id: 'WYND', name: 'WYND'}
  ],

  ociProductType: [
    {id: '', name: ''},
    {id: 'A', name: 'A'},
    {id: 'B', name: 'B'}
  ],
  ociRateType: [
    {id: '', name: ''},
    {id: 'Fixed', name: 'Fixed'},
    {id: 'Variable', name: 'Variable'}
  ],
  ociTermType: [
    {id: '', name: ''},
    {id: 'Closed', name: 'Closed'},
    {id: 'Open', name: 'Open'}
  ],
  ociPurposeOfLoans: [
    {id: '', name: ''},
    {id: 'Purchase', name: 'Purchase'},
    {id: 'Refinance', name: 'Refinance'},
    {id: 'Purchase plus Improvements', name: 'Purchase plus Improvements'},
    {id: 'Deficiency Sale', name: 'Deficiency Sale'},
    {id: 'Work Out', name: 'Work Out'},
    {id: 'Port', name: 'Port'},
    {id: 'Switch/Transfer', name: 'Switch/Transfer'},
    {id: 'ETO', name: 'ETO'},
  ],
  ociCreditType: [
    {id: '', name: ''},
    {id: 'Credit Card', name: 'Credit Card'},
    {id: 'LOC', name: 'LOC'}
  ],
  ociPaymentFrequency: [
    {id: '', name: ''},
    {id: 'Monthly', name: 'Monthly'},
    {id: 'Semi-monthly', name: 'Semi-monthly'},
    {id: 'Weekly', name: 'Weekly'},
    {id: 'Bi-weekly', name: 'Bi-weekly'},
    {id: 'Acc-weekly', name: 'Acc-weekly'},
    {id: 'Acc-biweekly', name: 'Acc-biweekly'},
    {id: 'Annually', name: 'Annually'},
    {id: 'Semi-annually', name: 'Semi-annually'},
    {id: 'Quarterly', name: 'Quarterly'}
  ],
  ociMProductName: [
    {id: '', name: ''},
    {id: 'productA', name: 'product A'},
    {id: 'productB', name: 'product B'},
    {id: 'productC', name: 'product C'},
    {id: 'productD', name: 'product D'}
  ],
  ociMortgageType: [
    {id: '', name: ''},
    {id: 'First', name: 'First'},
    {id: 'Second', name: 'Second'},
    {id: 'Third', name: 'Third'}
  ],
  ociLiabilityType:[
    {id: '', name: ''},
    {id: 'Mortgage', name: 'Mortgage'},
    {id: 'LOC', name: 'LOC'},
  ],
  ociOffsetPercent: [
    {id: '', name: ''},
    {id: '0', name: '0'},
    {id: '0.1', name: '10'},
    {id: '0.2', name: '20'},
    {id: '0.3', name: '30'},
    {id: '0.4', name: '40'},
    {id: '0.5', name: '50'},
    {id: '0.6', name: '60'},
    {id: '0.7', name: '70'},
    {id: '0.8', name: '80'},
    {id: '0.9', name: '90'},
    {id: '1', name: '100'}
  ],
  ociRentalOffsetOption: [
    {id: '', name: ''},
    {id: true, name: 'Yes'},
    {id: false, name: 'No'}
  ],
  ociYesOrNo: [
    {id: null, name: ''},
    {id: true, name: 'Yes'},
    {id: false, name: 'No'}
  ],
  ociPaymentType: [
    {id: '', name: ''},
    {id: '3% of Balance', name: '3% of Balance'},
    {id: '3% of limit', name: '3% of limit'},
    {id: 'Add Payment', name: 'Add Payment'}
  ],
  ociPaymentTypeExistingProperty: [
    {id: '', name: ''},
    {id: 'Add Payment', name: 'Add Payment'} //TODO: confirm that this can be removed (no dependencies) then remove it
  ],
  ociAssetType: [
    {id: '', name: ''},
    {id: 'Pension', name: 'Pension'},
    {id: 'RESP', name: 'RESP'},
    {id: 'Chequing', name: 'Chequing'},
    {id: 'GIC', name: 'GIC'},
    {id: 'Savings', name: 'Savings'},
    {id: 'RIF', name: 'RIF'},
    {id: 'Vehicle', name: 'Vehicle'},
    {id: 'RSP', name: 'RSP'},
    {id: 'Stock', name: 'Stock'},
    {id: 'Mutual Funds', name: 'Mutual Funds'},
    {id: 'Shares', name: 'Shares'},
    {id: 'TFSA', name: 'TFSA'},
    {id: 'Deposit', name: 'Deposit'},
    {id: 'Other', name: 'Other'}
  ],
  ociGenericLiabilityType: [
    {id: '', name: ''},
    {id: 'Loan', name: 'Loan'},
    {id: 'Credit Card', name: 'Credit Card'},
    {id: 'LOC', name: 'LOC'},
    {id: 'Rent', name: 'Rent'},
    {id: 'Other', name: 'Other'}
  ],
  ociOtherIncomeType: [
    {id: '', name: ''},
    {id: 'Salary', name: 'Salary'},
    {id: 'Spouse', name: 'Spouse'},
    {id: 'Bonus', name: 'Bonus'},
    {id: 'Commission', name: 'Commission'},
    {id: 'Invest', name: 'Invest'},
    {id: 'Other', name: 'Other'}
  ],
  ociIncomeFrequency: [
    {id: '', name: ''},
    {id: 'Weekly', name: 'Weekly'},
    {id: 'Bi-weekly', name: 'Bi-Weekly'},
    {id: 'Semi-monthly', name: 'Semi-monthly'},
    {id: 'Monthly', name: 'Monthly'},
    {id: 'Quarterly', name: 'Quarterly'},
    {id: 'Annually', name: 'Annually'}
  ],
  ociEmploymentOccupation: [
    {id: '', name: ''},
    {id: 'Agricultural', name: 'AGRICULTURAL'},
    {id: 'At Home', name: 'AT HOME'},
    {id: 'Construction', name: 'CONSTRUCTION'},
    {id: 'Executive', name: 'EXECUTIVE'},
    {id: 'Information Technology', name: 'INFORMATION TECHNOLOGY'},
    {id: 'Labourer', name: 'LABOURER'},
    {id: 'Manager', name: 'MANAGER'},
    {id: 'Military', name: 'MILITARY'},
    {id: 'Office Staff', name: 'OFFICE STAFF'},
    {id: 'Production', name: 'PRODUCTION'},
    {id: 'Professional', name: 'PROFESSIONAL'},
    {id: 'Sales', name: 'SALES'},
    {id: 'Self-Employed', name: 'SELF-EMPLOYED'},
    {id: 'Service', name: 'SERVICE'},
    {id: 'Student', name: 'STUDENT'},
    {id: 'Trades', name: 'TRADES'},
    {id: 'Unemployed', name: 'UNEMPLOYED'},
    {id: 'Other', name: 'OTHER'},
  ],
  ociIncomeType: [
    {id: '', name: ''},
    {id: 'Salaried', name: 'Salaried'},
    {id: 'Seasonal', name: 'Seasonal'},
    {id: 'Self Employed', name: 'Self Employed'},
    {id: 'Pensioner', name: 'Pensioner'},
    {id: 'Alimony', name: 'Alimony'},
    {id: 'Other', name: 'Other'}
  ],
  ociEmploymentIndustry: [
    {id: '', name: ''},
    {id: 'Construction', name: 'Construction'},
    {id: 'Government', name: 'Government'},
    {id: 'Health', name: 'Health'},
    {id: 'Education', name: 'Education'},
    {id: 'Hi-Tech', name: 'Hi-Tech'},
    {id: 'Retail Sales', name: 'Retail Sales'},
    {id: 'Leisure/Entertainment', name: 'Leisure/Entertainment'},
    {id: 'Banking/Finance', name: 'Banking/Finance'},
    {id: 'Transport', name: 'Transport'},
    {id: 'Services', name: 'Services'},
    {id: 'Manufacturing', name: 'Manufacturing'},
    {id: 'Farming/Natural Resources', name: 'Farming/Natural Resources'},
    {id: 'Other', name: 'Other'},
  ],
  ociEmploymentType: [
    {id: '', name: ''},
    {id: 'Full Time', name: 'Full Time'},
    {id: 'Part Time', name: 'Part Time'},
    {id: 'Retired', name: 'Retired'},
    {id: 'Seasonal', name: 'Seasonal'},
    {id: 'Self-Employed', name: 'Self-Employed'},
    {id: 'Student', name: 'Student'},
    {id: 'Unemployed', name: 'Unemployed'},
    {id: 'Other', name: 'Other'},
  ],
  ociAddressStatus: [
    {id: '', name: ''},
    {id: 'Current', name: 'Current'},
    {id: 'Previous', name: 'Previous'}
  ],
  ociEmploymentStatus: [
    {id: '', name: ''},
    {id: 'Current', name: 'Current'},
    {id: 'Previous', name: 'Previous'}
  ],
  ociResidenceStatus: [
    {id: '', name: ''},
    {id: 'Rent', name: 'Rent'},
    {id: 'Own', name: 'Own'}
  ],
  ociProvinces: [
    {id: '', name: ''},
    {id: 'ON', name: 'ON'},
    {id: 'QC', name: 'QC'},
    {id: 'AB', name: 'AB'},
    {id: 'BC', name: 'BC'},
    {id: 'NL', name: 'NL'},
    {id: 'PE', name: 'PE'},
    {id: 'NS', name: 'NS'},
    {id: 'NB', name: 'NB'},
    {id: 'MB', name: 'MB'},
    {id: 'SK', name: 'SK'},
    {id: 'YT', name: 'YT'},
    {id: 'NT', name: 'NT'},
    {id: 'NU', name: 'NU'}

  ],
  ociStates: [
    {id: '', name: ''},
    {id: 'AK', name: 'AK'},
    {id: 'AL', name: 'AL'},
    {id: 'AR', name: 'AR'},
    {id: 'AZ', name: 'AZ'},
    {id: 'CA', name: 'CA'},
    {id: 'CO', name: 'CO'},
    {id: 'CT', name: 'CT'},
    {id: 'DC', name: 'DC'},
    {id: 'DE', name: 'DE'},
    {id: 'FL', name: 'FL'},
    {id: 'GA', name: 'GA'},
    {id: 'HI', name: 'HI'},
    {id: 'IA', name: 'IA'},
    {id: 'ID', name: 'ID'},
    {id: 'IL', name: 'IL'},
    {id: 'IN', name: 'IN'},
    {id: 'KS', name: 'KS'},
    {id: 'KY', name: 'KY'},
    {id: 'LA', name: 'LA'},
    {id: 'MA', name: 'MA'},
    {id: 'MD', name: 'MD'},
    {id: 'MI', name: 'MI'},
    {id: 'MN', name: 'MN'},
    {id: 'MO', name: 'MO'},
    {id: 'MS', name: 'MS'},
    {id: 'MT', name: 'MT'},
    {id: 'NC', name: 'NC'},
    {id: 'ND', name: 'ND'},
    {id: 'NE', name: 'NE'},
    {id: 'NH', name: 'NH'},
    {id: 'NJ', name: 'NJ'},
    {id: 'NM', name: 'NM'},
    {id: 'NV', name: 'NV'},
    {id: 'OA', name: 'OA'},
    {id: 'OH', name: 'OH'},
    {id: 'OK', name: 'OK'},
    {id: 'OR', name: 'OR'},
    {id: 'PA', name: 'PA'},
    {id: 'RI', name: 'RI'},
    {id: 'SC', name: 'SC'},
    {id: 'SD', name: 'SD'},
    {id: 'TN', name: 'TN'},
    {id: 'TX', name: 'TX'},
    {id: 'UT', name: 'UT'},
    {id: 'VA', name: 'VA'},
    {id: 'VT', name: 'VT'},
    {id: 'WA', name: 'WA'},
    {id: 'WI', name: 'WI'},
    {id: 'WV', name: 'WV'},
    {id: 'WY', name: 'WY'},
  ],
  ociGender: [
    {id: '', name: ''},
    {id: 'Male', name: 'Male'},
    {id: 'Female', name: 'Female'},
    {id: 'Other', name: 'Other'}
  ],
  ociMaritalStatus: [
    {id: '', name: ''},
    {id: 'Never Married', name: 'Never Married'},
    {id: 'Married', name: 'Married'},
    {id: 'Divorced', name: 'Divorced'},
    {id: 'Common Law', name: 'Common Law'},
    {id: 'Widowed', name: 'Widowed'},
    {id: 'Annulled', name: 'Annulled'},
    {id: 'Separated', name: 'Separated'},
  ],
  ociBanks:[
    {id: 'empty', name: ''},
    {id: 'no', name: 'No pre-auth'},
    {id: 'none', name: 'Not On List'},
    {id: 'CIBC', name: 'CIBC'},
    {id: 'RBC', name: 'RBC'},
    {id: 'TD', name: 'TD'},
    {id: 'BMO', name: 'BMO'},
    {id: 'DUCA', name: 'DUCA'},
    {id: 'SCOTIA', name: 'SCOTIA BANK'},
  ],
  ociCountries:[
    {id: '', name: ''},
      {id: 'CANADA', name: 'CANADA'},
      {id: 'USA', name: 'USA'},
      {id: 'AFGHANISTAN', name: 'AFGHANISTAN'},
      {id: 'ANTARCTICA', name: 'ANTARCTICA'},
      {id: 'ALBANIA', name: 'ALBANIA'},
      {id: 'ALGERIA', name: 'ALGERIA'},
      {id: 'AMERICAN SAMOA', name: 'AMERICAN SAMOA'},
      {id: 'ANDORRA', name: 'ANDORRA'},
      {id: 'ANGOLA', name: 'ANGOLA'},
      {id: 'ANTIGUA AND BARBUDA', name: 'ANTIGUA AND BARBUDA'},
      {id: 'AZERBAIJAN', name: 'AZERBAIJAN'},
      {id: 'ARGENTINA', name: 'ARGENTINA'},
      {id: 'AUSTRALIA', name: 'AUSTRALIA'},
      {id: 'YUGOSLAVIA', name: 'YUGOSLAVIA'},
      {id: 'BAHRAIN', name: 'BAHRAIN'},
      {id: 'BANGLADESH', name: 'BANGLADESH'},
      {id: 'ARMENIA', name: 'ARMENIA'},
      {id: 'BARBADOS', name: 'BARBADOS'},
      {id: 'BELGIUM', name: 'BELGIUM'},
      {id: 'BERMUDA', name: 'BERMUDA'},
      {id: 'BHUTAN', name: 'BHUTAN'},
      {id: 'BOLIVIA', name: 'BOLIVIA'},
      {id: 'BOSNIA AND HERZEGOWINA', name: 'BOSNIA AND HERZEGOWINA'},
      {id: 'BOTSWANA', name: 'BOTSWANA'},
      {id: 'BOUVET ISLAND', name: 'BOUVET ISLAND'},
      {id: 'BRAZIL', name: 'BRAZIL'},
      {id: 'BELIZE', name: 'BELIZE'},
      {id: 'BRITISH INDIAN OCEAN TERRITORY', name: 'BRITISH INDIAN OCEAN TERRITORY'},
      {id: 'SOLOMON ISLANDS', name: 'SOLOMON ISLANDS'},
      {id: 'VIRGIN ISLANDS (BRITISH)', name: 'VIRGIN ISLANDS (BRITISH)'},
      {id: 'BRUNEI DARUSSALAM', name: 'BRUNEI DARUSSALAM'},
      {id: 'BULGARIA', name: 'BULGARIA'},
      {id: 'BURUNDI', name: 'BURUNDI'},
      {id: 'BELARUS', name: 'BELARUS'},
      {id: 'CAMBODIA', name: 'CAMBODIA'},
      {id: 'CAMEROON', name: 'CAMEROON'},
      {id: 'CAPE VERDE', name: 'CAPE VERDE'},
      {id: 'CAYMAN ISLANDS', name: 'CAYMAN ISLANDS'},
      {id: 'CENTRAL AFRICAN REPUBLIC', name: 'CENTRAL AFRICAN REPUBLIC'},
      {id: 'SRI LANKA', name: 'SRI LANKA'},
      {id: 'CHAD', name: 'CHAD'},
      {id: 'CHILE', name: 'CHILE'},
      {id: 'CHINA', name: 'CHINA'},
      {id: 'TAIWAN', name: 'TAIWAN'},
      {id: 'CHRISTMAS ISLAND', name: 'CHRISTMAS ISLAND'},
      {id: 'COCOS (KEELING) ISLANDS', name: 'COCOS (KEELING) ISLANDS'},
      {id: 'COLOMBIA', name: 'COLOMBIA'},
      {id: 'COMOROS', name: 'COMOROS'},
      {id: 'MAYOTTE', name: 'MAYOTTE'},
      {id: 'CONGO, Republic of', name: 'CONGO, Republic of'},
      {id: 'CONGO, Democratic Republic of (was Zaire)', name: 'CONGO, Democratic Republic of (was Zaire)'},
      {id: 'COOK ISLANDS', name: 'COOK ISLANDS'},
      {id: 'COSTA RICA', name: 'COSTA RICA'},
      {id: 'CROATIA (local name: Hrvatska)', name: 'CROATIA (local name: Hrvatska)'},
      {id: 'CUBA', name: 'CUBA'},
      {id: 'CYPRUS', name: 'CYPRUS'},
      {id: 'CZECH REPUBLIC', name: 'CZECH REPUBLIC'},
      {id: 'BENIN', name: 'BENIN'},
      {id: 'DENMARK', name: 'DENMARK'},
      {id: 'DOMINICA', name: 'DOMINICA'},
      {id: 'DOMINICAN REPUBLIC', name: 'DOMINICAN REPUBLIC'},
      {id: 'ECUADOR', name: 'ECUADOR'},
      {id: 'EL SALVADOR', name: 'EL SALVADOR'},
      {id: 'EQUATORIAL GUINEA', name: 'EQUATORIAL GUINEA'},
      {id: 'ETHIOPIA', name: 'ETHIOPIA'},
      {id: 'ERITREA', name: 'ERITREA'},
      {id: 'ESTONIA', name: 'ESTONIA'},
      {id: 'FAROE ISLANDS', name: 'FAROE ISLANDS'},
      {id: 'FALKLAND ISLANDS (MALVINAS)', name: 'FALKLAND ISLANDS (MALVINAS)'},
      {id: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS', name: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS'},
      {id: 'FIJI', name: 'FIJI'},
      {id: 'FINLAND', name: 'FINLAND'},
      {id: 'AALAND ISLANDS', name: 'AALAND ISLANDS'},
      {id: 'FRANCE', name: 'FRANCE'},
      {id: 'FRENCH GUIANA', name: 'FRENCH GUIANA'},
      {id: 'FRENCH POLYNESIA', name: 'FRENCH POLYNESIA'},
      {id: 'FRENCH SOUTHERN TERRITORIES', name: 'FRENCH SOUTHERN TERRITORIES'},
      {id: 'DJIBOUTI', name: 'DJIBOUTI'},
      {id: 'GABON', name: 'GABON'},
      {id: 'GEORGIA', name: 'GEORGIA'},
      {id: 'GAMBIA', name: 'GAMBIA'},
      {id: 'PALESTINIAN TERRITORY, Occupied', name: 'PALESTINIAN TERRITORY, Occupied'},
      {id: 'GERMANY', name: 'GERMANY'},
      {id: 'GHANA', name: 'GHANA'},
      {id: 'GIBRALTAR', name: 'GIBRALTAR'},
      {id: 'KIRIBATI', name: 'KIRIBATI'},
      {id: 'GREECE', name: 'GREECE'},
      {id: 'GREENLAND', name: 'GREENLAND'},
      {id: 'GRENADA', name: 'GRENADA'},
      {id: 'GUADELOUPE', name: 'GUADELOUPE'},
      {id: 'GUAM', name: 'GUAM'},
      {id: 'GUATEMALA', name: 'GUATEMALA'},
      {id: 'GUINEA', name: 'GUINEA'},
      {id: 'GUYANA', name: 'GUYANA'},
      {id: 'HAITI', name: 'HAITI'},
      {id: 'HEARD AND MC DONALD ISLANDS', name: 'HEARD AND MC DONALD ISLANDS'},
      {id: 'VATICAN CITY STATE (HOLY SEE)', name: 'VATICAN CITY STATE (HOLY SEE)'},
      {id: 'HONDURAS', name: 'HONDURAS'},
      {id: 'HONG KONG', name: 'HONG KONG'},
      {id: 'HUNGARY', name: 'HUNGARY'},
      {id: 'ICELAND', name: 'ICELAND'},
      {id: 'INDIA', name: 'INDIA'},
      {id: 'INDONESIA', name: 'INDONESIA'},
      {id: 'IRAN (ISLAMIC REPUBLIC OF)', name: 'IRAN (ISLAMIC REPUBLIC OF)'},
      {id: 'IRAQ', name: 'IRAQ'},
      {id: 'IRELAND', name: 'IRELAND'},
      {id: 'ISRAEL', name: 'ISRAEL'},
      {id: 'ITALY', name: 'ITALY'},
      {id: 'COTE DIVOIRE', name: 'COTE DIVOIRE'},
      {id: 'JAMAICA', name: 'JAMAICA'},
      {id: 'JAPAN', name: 'JAPAN'},
      {id: 'KAZAKHSTAN', name: 'KAZAKHSTAN'},
      {id: 'JORDAN', name: 'JORDAN'},
      {id: 'KENYA', name: 'KENYA'},
      {id: 'KOREA, DEMOCRATIC PEOPLES REPUBLIC OF', name: 'KOREA, DEMOCRATIC PEOPLES REPUBLIC OF'},
      {id: 'KOREA, REPUBLIC OF', name: 'KOREA, REPUBLIC OF'},
      {id: 'KUWAIT', name: 'KUWAIT'},
      {id: 'KYRGYZSTAN', name: 'KYRGYZSTAN'},
      {id: 'LAO PEOPLES DEMOCRATIC REPUBLIC', name: 'LAO PEOPLES DEMOCRATIC REPUBLIC'},
      {id: 'LEBANON', name: 'LEBANON'},
      {id: 'LESOTHO', name: 'LESOTHO'},
      {id: 'LATVIA', name: 'LATVIA'},
      {id: 'LIBERIA', name: 'LIBERIA'},
      {id: 'LIBYAN ARAB JAMAHIRIYA', name: 'LIBYAN ARAB JAMAHIRIYA'},
      {id: 'LIECHTENSTEIN', name: 'LIECHTENSTEIN'},
      {id: 'LITHUANIA', name: 'LITHUANIA'},
      {id: 'LUXEMBOURG', name: 'LUXEMBOURG'},
      {id: 'MACAU', name: 'MACAU'},
      {id: 'MADAGASCAR', name: 'MADAGASCAR'},
      {id: 'MALAWI', name: 'MALAWI'},
      {id: 'MALAYSIA', name: 'MALAYSIA'},
      {id: 'MALDIVES', name: 'MALDIVES'},
      {id: 'MALI', name: 'MALI'},
      {id: 'MALTA', name: 'MALTA'},
      {id: 'MARTINIQUE', name: 'MARTINIQUE'},
      {id: 'MAURITANIA', name: 'MAURITANIA'},
      {id: 'MAURITIUS', name: 'MAURITIUS'},
      {id: 'MEXICO', name: 'MEXICO'},
      {id: 'MONACO', name: 'MONACO'},
      {id: 'MONGOLIA', name: 'MONGOLIA'},
      {id: 'MOLDOVA, REPUBLIC OF', name: 'MOLDOVA, REPUBLIC OF'},
      {id: 'MONTSERRAT', name: 'MONTSERRAT'},
      {id: 'MOROCCO', name: 'MOROCCO'},
      {id: 'MOZAMBIQUE', name: 'MOZAMBIQUE'},
      {id: 'OMAN', name: 'OMAN'},
      {id: 'NAMIBIA', name: 'NAMIBIA'},
      {id: 'NAURU', name: 'NAURU'},
      {id: 'NEPAL', name: 'NEPAL'},
      {id: 'NETHERLANDS', name: 'NETHERLANDS'},
      {id: 'NETHERLANDS ANTILLES', name: 'NETHERLANDS ANTILLES'},
      {id: 'ARUBA', name: 'ARUBA'},
      {id: 'NEW CALEDONIA', name: 'NEW CALEDONIA'},
      {id: 'VANUATU', name: 'VANUATU'},
      {id: 'NEW ZEALAND', name: 'NEW ZEALAND'},
      {id: 'NICARAGUA', name: 'NICARAGUA'},
      {id: 'NIGER', name: 'NIGER'},
      {id: 'NIGERIA', name: 'NIGERIA'},
      {id: 'NIUE', name: 'NIUE'},
      {id: 'NORFOLK ISLAND', name: 'NORFOLK ISLAND'},
      {id: 'NORWAY', name: 'NORWAY'},
      {id: 'NORTHERN MARIANA ISLANDS', name: 'NORTHERN MARIANA ISLANDS'},
      {id: 'UNITED STATES MINOR OUTLYING ISLANDS', name: 'UNITED STATES MINOR OUTLYING ISLANDS'},
      {id: 'MICRONESIA, FEDERATED STATES OF', name: 'MICRONESIA, FEDERATED STATES OF'},
      {id: 'MARSHALL ISLANDS', name: 'MARSHALL ISLANDS'},
      {id: 'PALAU', name: 'PALAU'},
      {id: 'PAKISTAN', name: 'PAKISTAN'},
      {id: 'PANAMA', name: 'PANAMA'},
      {id: 'PAPUA NEW GUINEA', name: 'PAPUA NEW GUINEA'},
      {id: 'PARAGUAY', name: 'PARAGUAY'},
      {id: 'PERU', name: 'PERU'},
      {id: 'PHILIPPINES', name: 'PHILIPPINES'},
      {id: 'PITCAIRN', name: 'PITCAIRN'},
      {id: 'POLAND', name: 'POLAND'},
      {id: 'PORTUGAL', name: 'PORTUGAL'},
      {id: 'GUINEA-BISSAU', name: 'GUINEA-BISSAU'},
      {id: 'TIMOR-LESTE', name: 'TIMOR-LESTE'},
      {id: 'PUERTO RICO', name: 'PUERTO RICO'},
      {id: 'QATAR', name: 'QATAR'},
      {id: 'REUNION', name: 'REUNION'},
      {id: 'ROMANIA', name: 'ROMANIA'},
      {id: 'RUSSIAN FEDERATION', name: 'RUSSIAN FEDERATION'},
      {id: 'RWANDA', name: 'RWANDA'},
      {id: 'SAINT HELENA', name: 'SAINT HELENA'},
      {id: 'SAINT KITTS AND NEVIS', name: 'SAINT KITTS AND NEVIS'},
      {id: 'ANGUILLA', name: 'ANGUILLA'},
      {id: 'SAINT LUCIA', name: 'SAINT LUCIA'},
      {id: 'SAINT PIERRE AND MIQUELON', name: 'SAINT PIERRE AND MIQUELON'},
      {id: 'SAINT VINCENT AND THE GRENADINES', name: 'SAINT VINCENT AND THE GRENADINES'},
      {id: 'SAN MARINO', name: 'SAN MARINO'},
      {id: 'SAO TOME AND PRINCIPE', name: 'SAO TOME AND PRINCIPE'},
      {id: 'SAUDI ARABIA', name: 'SAUDI ARABIA'},
      {id: 'SENEGAL', name: 'SENEGAL'},
      {id: 'SEYCHELLES', name: 'SEYCHELLES'},
      {id: 'SIERRA LEONE', name: 'SIERRA LEONE'},
      {id: 'SINGAPORE', name: 'SINGAPORE'},
      {id: 'SLOVAKIA', name: 'SLOVAKIA'},
      {id: 'VIET NAM', name: 'VIET NAM'},
      {id: 'SLOVENIA', name: 'SLOVENIA'},
      {id: 'SOMALIA', name: 'SOMALIA'},
      {id: 'SOUTH AFRICA', name: 'SOUTH AFRICA'},
      {id: 'ZIMBABWE', name: 'ZIMBABWE'},
      {id: 'SPAIN', name: 'SPAIN'},
      {id: 'WESTERN SAHARA', name: 'WESTERN SAHARA'},
      {id: 'SUDAN', name: 'SUDAN'},
      {id: 'SURIname', name: 'SURIname'},
      {id: 'SVALBARD AND JAN MAYEN ISLANDS', name: 'SVALBARD AND JAN MAYEN ISLANDS'},
      {id: 'SWAZILAND', name: 'SWAZILAND'},
      {id: 'SWEDEN', name: 'SWEDEN'},
      {id: 'SWITZERLAND', name: 'SWITZERLAND'},
      {id: 'SYRIAN ARAB REPUBLIC', name: 'SYRIAN ARAB REPUBLIC'},
      {id: 'TAJIKISTAN', name: 'TAJIKISTAN'},
      {id: 'THAILAND', name: 'THAILAND'},
      {id: 'TOGO', name: 'TOGO'},
      {id: 'TOKELAU', name: 'TOKELAU'},
      {id: 'TONGA', name: 'TONGA'},
      {id: 'TRINIDAD AND TOBAGO', name: 'TRINIDAD AND TOBAGO'},
      {id: 'UNITED ARAB EMIRATES', name: 'UNITED ARAB EMIRATES'},
      {id: 'TUNISIA', name: 'TUNISIA'},
      {id: 'TURKEY', name: 'TURKEY'},
      {id: 'TURKMENISTAN', name: 'TURKMENISTAN'},
      {id: 'TUVALU', name: 'TUVALU'},
      {id: 'UGANDA', name: 'UGANDA'},
      {id: 'UKRAINE', name: 'UKRAINE'},
      {id: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF', name: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF'},
      {id: 'EGYPT', name: 'EGYPT'},
      {id: 'UNITED KINGDOM', name: 'UNITED KINGDOM'},
      {id: 'TANZANIA, UNITED REPUBLIC OF', name: 'TANZANIA, UNITED REPUBLIC OF'},
      {id: 'UNITED STATES', name: 'UNITED STATES'},
      {id: 'VIRGIN ISLANDS (U.S.)', name: 'VIRGIN ISLANDS (U.S.)'},
      {id: 'BURKINA FASO', name: 'BURKINA FASO'},
      {id: 'URUGUAY', name: 'URUGUAY'},
      {id: 'UZBEKISTAN', name: 'UZBEKISTAN'},
      {id: 'VENEZUELA', name: 'VENEZUELA'},
      {id: 'WALLIS AND FUTUNA ISLANDS', name: 'WALLIS AND FUTUNA ISLANDS'},
      {id: 'SAMOA', name: 'SAMOA'},
      {id: 'YEMEN', name: 'YEMEN'},
      {id: 'SERBIA AND MONTENEGRO', name: 'SERBIA AND MONTENEGRO'},
      {id: 'ZAMBIA', name: 'ZAMBIA'}
    ],
  personStatus: [
    {id: '', name: ''},
    {id: 'active', name: 'Active'},
    {id: 'inactive', name: 'Inactive'}
  ],
  // firmStatus = 'New' is a way for us to distinguish between an Active firm with ongoing projects, and a newly setup
  // but never used Firm..  this will help filter large dropdown lists for the analytics and performance screens.
  //Do not add an empty string or null here since lender pre-auth firms are given that status, change the status of these firms to something else if you do not
  //want it to be an empty string or null
  firmStatus: [
    {id: 'new', name: 'New'},
    {id: 'active', name: 'Active'},
    {id: 'inactive', name: 'Inactive'}
  ],
  timezone: [
    {id: '', name: ''},
    {id: 'EST', name: 'EST'}
  ],
  namePrefix: [
    {id: '', name: ''},
    {id: 'Ms', name: 'Ms'},
    {id: 'Miss', name: 'Miss'},
    {id: 'Mrs', name: 'Mrs'},
    {id: 'Mr', name: 'Mr'},
    {id: 'Master', name: 'Master'},
    {id: 'Fr', name: 'Father'},
    {id: 'Rev', name: 'Rev'},
    {id: 'Dr', name: 'Doctor'},
    {id: 'Atty', name: 'Attorney'},
    {id: 'Hon', name: 'Honorable'},
    {id: 'Prof', name: 'Professor'},
    {id: 'Pres', name: 'President'},
    {id: 'VP', name: 'Vice President'},
    {id: 'Gov', name: 'Governor'},
    {id: 'Ofc', name: 'Officer'}
  ],
  nameSuffix: [
    {id: '', name: ''},
    {id: 'Jr', name: 'Junior'},
    {id: 'Sr', name: 'Senior'},
    {id: '2nd', name: '2nd'},
    {id: '3rd', name: '3rd'},
    {id: 'II', name: 'II'},
    {id: 'III', name: 'III'},
    {id: 'Esq', name: 'Esquire'},
    {id: 'CPA', name: 'CPA'},
    {id: 'DC', name: 'DC'},
    {id: 'DDS', name: 'DDS'},
    {id: 'VM', name: 'VM'},
    {id: 'JD', name: 'JD'},
    {id: 'MD', name: 'MD'},
    {id: 'PhD', name: 'Phd'}
  ],
  phoneType: [
    {id: '', name: ''},
    {id: 'cell', name: 'Mobile'},
    {id: 'home', name: 'Home'},
    {id: 'work', name: 'Work'}
  ],
  firmGroup: [
    {id: '', name: ''},
    {id: 'sales', name: 'Sales'},
    {id: 'marketing', name: 'Marketing'},
    {id: 'management', name: 'Management'},
    {id: 'accounts', name: 'Accounting'}
  ],
  firmType: [
    {id: '', name: ''},
    {id: 'oci', name: 'OneClose'},
    {id: 'lender', name: 'Lender'},
    {id: 'developer', name: 'Developer'},
    {id: 'legal-closing', name: 'Closing Lawyer'},
  ],
  ociPurchaserEntryPath: [
    {id: 'purchaser/TermsOfService', name: 'purchaser/TermsOfService'},
    {id: 'prospect/info', name: 'prospect/info'},
    {id: 'purchaser/survey', name: 'purchaser/survey'},

  ],
  brokerageRepresenting: [
    {id: '', name: ''},
    {id: 'Borrower', name: 'The Borrower, not the Lender'},
    {id: 'Lender', name: 'The Lender, not the Borrower'},
    {id: 'Borrower-Lender', name: 'The Borrower & the Lender, not to the preference of either'}
  ],
  ociHoldCo:[
    {id: null, name: ""},
    {id: true, name: "Yes"},
    {id: false, name: "No"},
    ],
  ducaOccupationCodes: [
    {id: 'Contractor- heavy equipment', name: 'Contractor- heavy equipment', value: 'yo'},
    {id: 'Lumber grader', name: 'Lumber grader'},
    {id: 'Wood processing inspectors and graders', name: 'Wood processing inspectors and graders'},
    {id: 'Textile fibre and yarn Inspector', name: 'Textile fibre and yarn Inspector'},
    {id: 'Hide and pelt processing machine operator', name: 'Hide and pelt processing machine operator'},
    {id: 'Process controler', name: 'Process controler'},
    {id: 'Machine operators- food and beverage', name: 'Machine operators- food and beverage'},
    {id: 'Industrial butchers and meat cutters', name: 'Industrial butchers and meat cutters'},
    {id: 'Poultry preparers workers', name: 'Poultry preparers workers'},
    {id: 'Inspectors-electrical appliance', name: 'Inspectors-electrical appliance'},
    {id: 'Inspectors - equipment manufacturing', name: 'Inspectors - equipment manufacturing'},
    {id: 'Assembler -equipment manufacturing', name: 'Assembler -equipment manufacturing'},
    {id: 'Assemblers- electrical appliance', name: 'Assemblers- electrical appliance'},
    {id: 'Assemblers - industrial electrical motors', name: 'Assemblers - industrial electrical motors'},
    {id: 'Assemblers- fabricators', name: 'Assemblers- fabricators'},
    {id: 'Machine operators- electrical manufacturing', name: 'Machine operators- electrical manufacturing'},
    {id: 'Inspectors -electrical manufacturing', name: 'Inspectors -electrical manufacturing'},
    {id: 'Labourers in food and beverage', name: 'Labourers in food and beverage'},
    {id: 'Cabinet minister', name: 'Cabinet minister'},
    {id: 'City councillor', name: 'City councillor'},
    {id: 'First Nations band chief', name: 'First Nations band chief'},
    {id: 'Governor general', name: 'Governor general'},
    {id: 'Lieutenant-governor', name: 'Lieutenant-governor'},
    {id: 'Mayor', name: 'Mayor'},
    {id: 'Member of Legislative Assembly (MLA)', name: 'Member of Legislative Assembly (MLA)'},
    {id: 'Member of Parliament (MP)', name: 'Member of Parliament (MP)'},
    {id: 'Member of the National Assembly (MNA)', name: 'Member of the National Assembly (MNA)'},
    {id: 'Member of the Provincial Parliament (MPP)', name: 'Member of the Provincial Parliament (MPP)'},
    {id: 'Premier', name: 'Premier'},
    {id: 'Prime minister', name: 'Prime minister'},
    {id: 'School board trustee', name: 'School board trustee'},
    {id: 'Senator', name: 'Senator'},
    {id: 'Senior government managers and officials', name: 'Senior government managers and officials'},
    {id: 'Senior managers - financial Services', name: 'Senior managers - financial Services'},
    {id: 'Senior managers - Chief financial officer', name: 'Senior managers - Chief financial officer'},
    {id: 'Senior managers - Communications Services', name: 'Senior managers - Communications Services'},
    {id: 'Chief executive officer', name: 'Chief executive officer'},
    {id: 'Senior managers - Real Estate', name: 'Senior managers - Real Estate'},
    {id: 'Senior managers - healthcare', name: 'Senior managers - healthcare'},
    {id: 'Senior managers - education services', name: 'Senior managers - education services'},
    {id: 'Senior managers - social/community services', name: 'Senior managers - social/community services'},
    {id: 'Senior managers - trade services', name: 'Senior managers - trade services'},
    {id: 'Senior managers - broadcasting', name: 'Senior managers - broadcasting'},
    {id: 'Senior managers - Communication services', name: 'Senior managers - Communication services'},
    {id: 'Senior managers - construction', name: 'Senior managers - construction'},
    {id: 'Senior managers - transportation', name: 'Senior managers - transportation'},
    {id: 'Senior managers - production', name: 'Senior managers - production'},
    {id: 'Senior managers - utilities', name: 'Senior managers - utilities'},
    {id: 'Financial/Accounting managers', name: 'Financial/Accounting managers'},
    {id: 'Human resources managers', name: 'Human resources managers'},
    {id: 'Purchasing managers', name: 'Purchasing managers'},
    {id: 'Administrative services managers', name: 'Administrative services managers'},
    {id: 'Insurance managers', name: 'Insurance managers'},
    {id: 'Real Estate managers', name: 'Real Estate managers'},
    {id: 'Financial brokerage managers', name: 'Financial brokerage managers'},
    {id: 'Banking managers', name: 'Banking managers'},
    {id: 'Investment managers', name: 'Investment managers'},
    {id: 'Advertising and marketing managers', name: 'Advertising and marketing managers'},
    {id: 'Communications and public relations managers', name: 'Communications and public relations managers'},
    {id: 'Telecommunication carriers managers', name: 'Telecommunication carriers managers'},
    {id: 'Postal and courier services managers', name: 'Postal and courier services managers'},
    {id: 'Engineering managers', name: 'Engineering managers'},
    {id: 'Architecture and science managers', name: 'Architecture and science managers'},
    {id: 'Computer and information systems managers', name: 'Computer and information systems managers'},
    {id: 'Managers in health care', name: 'Managers in health care'},
    {id: 'Government managers - health administration', name: 'Government managers - health administration'},
    {id: 'Government managers social policy development', name: 'Government managers social policy development'},
    {id: 'Government managers - program administration', name: 'Government managers - program administration'},
    {id: 'Government managers - economic analysis', name: 'Government managers - economic analysis'},
    {id: 'Government managers - policy development', name: 'Government managers - policy development'},
    {id: 'Government managers - education policy development', name: 'Government managers - education policy development'},
    {id: 'Managers in public administration', name: 'Managers in public administration'},
    {id: 'Administrators - post-secondary education', name: 'Administrators - post-secondary education'},
    {id: 'Administrators -vocational training', name: 'Administrators -vocational training'},
    {id: 'Administrators of elementary education', name: 'Administrators of elementary education'},
    {id: 'Administrators of secondary education', name: 'Administrators of secondary education'},
    {id: 'School principals', name: 'School principals'},
    {id: 'Managers in social services', name: 'Managers in social services'},
    {id: 'Managers of community and correctional services', name: 'Managers of community and correctional services'},
    {id: 'Commissioned police officers', name: 'Commissioned police officers'},
    {id: 'Fire chiefs and senior firefighting officers', name: 'Fire chiefs and senior firefighting officers'},
    {id: 'Canadian Forces-Commissioned officers', name: 'Canadian Forces-Commissioned officers'},
    {id: 'Library managers', name: 'Library managers'},
    {id: 'Archive manager', name: 'Archive manager'},
    {id: 'museum and art gallery manager', name: 'museum and art gallery manager'},
    {id: 'Managers - publishing and broadcasting', name: 'Managers - publishing and broadcasting'},
    {id: 'Manager -performing arts', name: 'Manager -performing arts'},
    {id: 'Recreation and sports directors', name: 'Recreation and sports directors'},
    {id: 'and fitness program and service', name: 'and fitness program and service'},
    {id: 'Corporate sales managers', name: 'Corporate sales managers'},
    {id: 'Retail and wholesale trade managers', name: 'Retail and wholesale trade managers'},
    {id: 'Restaurant and food service managers', name: 'Restaurant and food service managers'},
    {id: 'Accommodation service managers', name: 'Accommodation service managers'},
    {id: 'Managers in customer and personal services', name: 'Managers in customer and personal services'},
    {id: 'Construction managers', name: 'Construction managers'},
    {id: 'Home building managers', name: 'Home building managers'},
    {id: 'renovation managers', name: 'renovation managers'},
    {id: 'Facility operation managers', name: 'Facility operation managers'},
    {id: 'Maintenance managers', name: 'Maintenance managers'},
    {id: 'Managers in transportation', name: 'Managers in transportation'},
    {id: 'Managers in natural resources production', name: 'Managers in natural resources production'},
    {id: 'Managers in fishing production', name: 'Managers in fishing production'},
    {id: 'Managers in agriculture', name: 'Managers in agriculture'},
    {id: 'Managers in horticulture', name: 'Managers in horticulture'},
    {id: 'Managers in aquaculture', name: 'Managers in aquaculture'},
    {id: 'Manufacturing managers', name: 'Manufacturing managers'},
    {id: 'Utilities managers', name: 'Utilities managers'},
    {id: 'Financial auditors and accountants', name: 'Financial auditors and accountants'},
    {id: 'Risk Officers', name: 'Risk Officers'},
    {id: 'Compliance Officers', name: 'Compliance Officers'},
    {id: 'Financial and investment analysts', name: 'Financial and investment analysts'},
    {id: 'Securities agents', name: 'Securities agents'},
    {id: 'Investment dealers and brokers', name: 'Investment dealers and brokers'},
    {id: 'Human resources professionals', name: 'Human resources professionals'},
    {id: 'Business management consulting', name: 'Business management consulting'},
    {id: 'Advertising Professional', name: 'Advertising Professional'},
    {id: 'Marketing Professional', name: 'Marketing Professional'},
    {id: 'Supervisors, general office', name: 'Supervisors, general office'},
    {id: 'Administrative support workers', name: 'Administrative support workers'},
    {id: 'Supervisors of Finance Workers', name: 'Supervisors of Finance Workers'},
    {id: 'Supervisors of insurance office workers', name: 'Supervisors of insurance office workers'},
    {id: 'Supervisors of library servies', name: 'Supervisors of library servies'},
    {id: 'Supervisors of information services', name: 'Supervisors of information services'},
    {id: 'Supervisors, mail and message distribution', name: 'Supervisors, mail and message distribution'},
    {id: 'Supervisors, supply chain, tracking', name: 'Supervisors, supply chain, tracking'},
    {id: 'Administrative officers', name: 'Administrative officers'},
    {id: 'Executive assistants', name: 'Executive assistants'},
    {id: 'Human resources Administration officers', name: 'Human resources Administration officers'},
    {id: 'Talent Acquisition and recruitment officers', name: 'Talent Acquisition and recruitment officers'},
    {id: 'Property administrators', name: 'Property administrators'},
    {id: 'Purchasing agents and officers', name: 'Purchasing agents and officers'},
    {id: 'Conference and event planners', name: 'Conference and event planners'},
    {id: 'Court officers', name: 'Court officers'},
    {id: 'Justices of the peace', name: 'Justices of the peace'},
    {id: 'Employment insurance officers', name: 'Employment insurance officers'},
    {id: 'Immigration Officers', name: 'Immigration Officers'},
    {id: 'Border services Agents', name: 'Border services Agents'},
    {id: 'Administrative assistants', name: 'Administrative assistants'},
    {id: 'Legal administrative assistants', name: 'Legal administrative assistants'},
    {id: 'Medical administrative assistants', name: 'Medical administrative assistants'},
    {id: 'Court reporters', name: 'Court reporters'},
    {id: 'Medical transcriptionists', name: 'Medical transcriptionists'},
    {id: 'Health information management Officer', name: 'Health information management Officer'},
    {id: 'Records management technician', name: 'Records management technician'},
    {id: 'Statistical officer', name: 'Statistical officer'},
    {id: 'Statistics Research support Officer', name: 'Statistics Research support Officer'},
    {id: 'Accounting technician', name: 'Accounting technician'},
    {id: 'Bookkeepers', name: 'Bookkeepers'},
    {id: 'Insurance adjusters', name: 'Insurance adjusters'},
    {id: 'Insurance claims examiners', name: 'Insurance claims examiners'},
    {id: 'Insurance underwriters', name: 'Insurance underwriters'},
    {id: 'Assessors, valuators and appraisers', name: 'Assessors, valuators and appraisers'},
    {id: 'Customs, shipment brokers', name: 'Customs, shipment brokers'},
    {id: 'General office support workers', name: 'General office support workers'},
    {id: 'Receptionists', name: 'Receptionists'},
    {id: 'Personnel clerks', name: 'Personnel clerks'},
    {id: 'Court clerks', name: 'Court clerks'},
    {id: 'Data entry clerks', name: 'Data entry clerks'},
    {id: 'Desktop publishing operators', name: 'Desktop publishing operators'},
    {id: 'Accounting clerks', name: 'Accounting clerks'},
    {id: 'Payroll clerks', name: 'Payroll clerks'},
    {id: 'Banking Operations Officer', name: 'Banking Operations Officer'},
    {id: 'InsuranceOperations Officer', name: 'InsuranceOperations Officer'},
    {id: 'Collectors', name: 'Collectors'},
    {id: 'Library assistants and clerks', name: 'Library assistants and clerks'},
    {id: 'Correspondence, publication clerk', name: 'Correspondence, publication clerk'},
    {id: 'Regulatory clerk', name: 'Regulatory clerk'},
    {id: 'Survey interviewers', name: 'Survey interviewers'},
    {id: 'Statistical clerks', name: 'Statistical clerks'},
    {id: 'Mail, postal and related workers', name: 'Mail, postal and related workers'},
    {id: 'Letter carrier', name: 'Letter carrier'},
    {id: 'Couriers', name: 'Couriers'},
    {id: 'Messengers and door-to-door distributors', name: 'Messengers and door-to-door distributors'},
    {id: 'Shippers and receivers', name: 'Shippers and receivers'},
    {id: 'Storekeeper', name: 'Storekeeper'},
    {id: 'Production logistics co-ordinators', name: 'Production logistics co-ordinators'},
    {id: 'Purchasing and inventory control worker', name: 'Purchasing and inventory control worker'},
    {id: 'Dispatchers', name: 'Dispatchers'},
    {id: 'Transportation route and crew schedulers', name: 'Transportation route and crew schedulers'},
    {id: 'Physicists and astronomers', name: 'Physicists and astronomers'},
    {id: 'Chemists', name: 'Chemists'},
    {id: 'Geoscientists and oceanographers', name: 'Geoscientists and oceanographers'},
    {id: 'Meteorologists and climatologists', name: 'Meteorologists and climatologists'},
    {id: 'Biologists and related scientists', name: 'Biologists and related scientists'},
    {id: 'Forestry professionals', name: 'Forestry professionals'},
    {id: 'Agricultural representatives', name: 'Agricultural representatives'},
    {id: 'Agricultural consultants', name: 'Agricultural consultants'},
    {id: 'Civil engineers', name: 'Civil engineers'},
    {id: 'Mechanical engineers', name: 'Mechanical engineers'},
    {id: 'Electrical and electronics engineers', name: 'Electrical and electronics engineers'},
    {id: 'Chemical engineers', name: 'Chemical engineers'},
    {id: 'Industrial and manufacturing engineers', name: 'Industrial and manufacturing engineers'},
    {id: 'Metallurgical and materials engineers', name: 'Metallurgical and materials engineers'},
    {id: 'Mining engineers', name: 'Mining engineers'},
    {id: 'Geological engineers', name: 'Geological engineers'},
    {id: 'Petroleum engineers', name: 'Petroleum engineers'},
    {id: 'Aerospace engineers', name: 'Aerospace engineers'},
    {id: 'Computer engineers', name: 'Computer engineers'},
    {id: 'Architects', name: 'Architects'},
    {id: 'Landscape architects', name: 'Landscape architects'},
    {id: 'Urban and land use planners', name: 'Urban and land use planners'},
    {id: 'Land surveyors', name: 'Land surveyors'},
    {id: 'Mathematicians', name: 'Mathematicians'},
    {id: 'Statisticians and actuaries', name: 'Statisticians and actuaries'},
    {id: 'Information systems analysts', name: 'Information systems analysts'},
    {id: 'Information systems consultants', name: 'Information systems consultants'},
    {id: 'Database analysts', name: 'Database analysts'},
    {id: 'Data administrators', name: 'Data administrators'},
    {id: 'Software engineers and designers', name: 'Software engineers and designers'},
    {id: 'Computer programmers', name: 'Computer programmers'},
    {id: 'Interactive media developers', name: 'Interactive media developers'},
    {id: 'Web designers and developers', name: 'Web designers and developers'},
    {id: 'Chemical technologists and technicians', name: 'Chemical technologists and technicians'},
    {id: 'Geological and mineral technologists', name: 'Geological and mineral technologists'},
    {id: 'Geological and mineral technicians', name: 'Geological and mineral technicians'},
    {id: 'Biological technologists and technicians', name: 'Biological technologists and technicians'},
    {id: 'Agricultural and fish products inspectors', name: 'Agricultural and fish products inspectors'},
    {id: 'Forestry technologists and technicians', name: 'Forestry technologists and technicians'},
    {id: 'Conservation and fishery officers', name: 'Conservation and fishery officers'},
    {id: 'Landscape and horticulture technicians', name: 'Landscape and horticulture technicians'},
    {id: 'Landscape and horticulture specialists', name: 'Landscape and horticulture specialists'},
    {id: 'Civil engineering technologists', name: 'Civil engineering technologists'},
    {id: 'Civil engineering technicians', name: 'Civil engineering technicians'},
    {id: 'Mechanical engineering technologists', name: 'Mechanical engineering technologists'},
    {id: 'Mechanical engineering technicians', name: 'Mechanical engineering technicians'},
    {id: 'Industrial engineer', name: 'Industrial engineer'},
    {id: 'Manufacturing technologists and technician', name: 'Manufacturing technologists and technician'},
    {id: 'Construction estimators', name: 'Construction estimators'},
    {id: 'Electrical and electronics engineer', name: 'Electrical and electronics engineer'},
    {id: 'Electrical and electronics technician', name: 'Electrical and electronics technician'},
    {id: 'Electronic service technicians', name: 'Electronic service technicians'},
    {id: 'Industrial instrument technicians', name: 'Industrial instrument technicians'},
    {id: 'Industrial instrument mechanics', name: 'Industrial instrument mechanics'},
    {id: 'Aircraft instrument technician', name: 'Aircraft instrument technician'},
    {id: 'Aircraft instrument inspector', name: 'Aircraft instrument inspector'},
    {id: 'Electrical and avionics mechanics, technician', name: 'Electrical and avionics mechanics, technician'},
    {id: 'Electrical and avionics mechanics inspector', name: 'Electrical and avionics mechanics inspector'},
    {id: 'Architectural technologists and technicians', name: 'Architectural technologists and technicians'},
    {id: 'Industrial designers', name: 'Industrial designers'},
    {id: 'Drafting technologists and technicians', name: 'Drafting technologists and technicians'},
    {id: 'Land survey technologists and technicians', name: 'Land survey technologists and technicians'},
    {id: 'Technician in geomatics and meteorology', name: 'Technician in geomatics and meteorology'},
    {id: 'Engineering inspectors and regulatory officers', name: 'Engineering inspectors and regulatory officers'},
    {id: 'Inspectors in public and environmental health', name: 'Inspectors in public and environmental health'},
    {id: 'Occupational health and safety inspectors', name: 'Occupational health and safety inspectors'},
    {id: 'Construction inspectors', name: 'Construction inspectors'},
    {id: 'Air pilots', name: 'Air pilots'},
    {id: 'Flight engineers', name: 'Flight engineers'},
    {id: 'Flying instructors', name: 'Flying instructors'},
    {id: 'Air traffic controllers', name: 'Air traffic controllers'},
    {id: 'Deck officers, water transport', name: 'Deck officers, water transport'},
    {id: 'Engineer officers, water transport', name: 'Engineer officers, water transport'},
    {id: 'Railway traffic controllers', name: 'Railway traffic controllers'},
    {id: 'Marine traffic regulators', name: 'Marine traffic regulators'},
    {id: 'Computer network technicians', name: 'Computer network technicians'},
    {id: 'User support technicians', name: 'User support technicians'},
    {id: 'Information systems testing technician', name: 'Information systems testing technician'},
    {id: 'Nursing co-ordinators and supervisors', name: 'Nursing co-ordinators and supervisors'},
    {id: 'Registered nurses', name: 'Registered nurses'},
    {id: 'Registered psychiatric nurses', name: 'Registered psychiatric nurses'},
    {id: 'Specialist physicians', name: 'Specialist physicians'},
    {id: 'General practitioners', name: 'General practitioners'},
    {id: 'Family physicians', name: 'Family physicians'},
    {id: 'Dentists', name: 'Dentists'},
    {id: 'Veterinarians', name: 'Veterinarians'},
    {id: 'Optometrists', name: 'Optometrists'},
    {id: 'Chiropractors', name: 'Chiropractors'},
    {id: 'Allied primary health practitioners', name: 'Allied primary health practitioners'},
    {id: 'Pharmacists', name: 'Pharmacists'},
    {id: 'Dietitians and nutritionists', name: 'Dietitians and nutritionists'},
    {id: 'Audiologists and speech-language pathologists', name: 'Audiologists and speech-language pathologists'},
    {id: 'Physiotherapists', name: 'Physiotherapists'},
    {id: 'Occupational therapists', name: 'Occupational therapists'},
    {id: 'Medical laboratory technologists', name: 'Medical laboratory technologists'},
    {id: 'Medical laboratory technician', name: 'Medical laboratory technician'},
    {id: "Pathologists' assistants", name: "Pathologists' assistants"},
    {id: 'Animal health technologist', name: 'Animal health technologist'},
    {id: 'Veterinary technicians', name: 'Veterinary technicians'},
    {id: 'Respiratory therapists', name: 'Respiratory therapists'},
    {id: 'Clinical perfusionists', name: 'Clinical perfusionists'},
    {id: 'Cardiopulmonary technologist', name: 'Cardiopulmonary technologist'},
    {id: 'Medical radiation technologists', name: 'Medical radiation technologists'},
    {id: 'Medical sonographers', name: 'Medical sonographers'},
    {id: 'Cardiology technologists', name: 'Cardiology technologists'},
    {id: 'Electrophysiological diagnostic technologists', name: 'Electrophysiological diagnostic technologists'},
    {id: 'Denturists', name: 'Denturists'},
    {id: 'Dental hygienists and dental therapists', name: 'Dental hygienists and dental therapists'},
    {id: 'Dental technologists technicians', name: 'Dental technologists technicians'},
    {id: 'Opticians', name: 'Opticians'},
    {id: 'Practitioners of natural healing', name: 'Practitioners of natural healing'},
    {id: 'Licensed practical nurses', name: 'Licensed practical nurses'},
    {id: 'Paramedical occupations', name: 'Paramedical occupations'},
    {id: 'Massage therapists', name: 'Massage therapists'},
    {id: 'Therapy and assessment Professionals', name: 'Therapy and assessment Professionals'},
    {id: 'Dental assistants', name: 'Dental assistants'},
    {id: 'Nurse aides and orderlies', name: 'Nurse aides and orderlies'},
    {id: 'Patient service associate', name: 'Patient service associate'},
    {id: 'University professors and lecturers', name: 'University professors and lecturers'},
    {id: 'Post-secondary teaching assistants', name: 'Post-secondary teaching assistants'},
    {id: 'University research assistants', name: 'University research assistants'},
    {id: 'College and other vocational instructors', name: 'College and other vocational instructors'},
    {id: 'Secondary school teachers', name: 'Secondary school teachers'},
    {id: 'Elementary school teacher', name: 'Elementary school teacher'},
    {id: 'kindergarten Teacher', name: 'kindergarten Teacher'},
    {id: 'Educational counsellors', name: 'Educational counsellors'},
    {id: 'Judges', name: 'Judges'},
    {id: 'Lawyers and Quebec notaries', name: 'Lawyers and Quebec notaries'},
    {id: 'Psychologists', name: 'Psychologists'},
    {id: 'Social workers', name: 'Social workers'},
    {id: 'Familyand marriage counsellor', name: 'Familyand marriage counsellor'},
    {id: 'Professional occupations in religion', name: 'Professional occupations in religion'},
    {id: 'Probation and parole officer', name: 'Probation and parole officer'},
    {id: 'Employment counsellors', name: 'Employment counsellors'},
    {id: 'Natural science policy researchers officer', name: 'Natural science policy researchers officer'},
    {id: 'Applied science policy consultant', name: 'Applied science policy consultant'},
    {id: 'Applied science policy researchers program officer', name: 'Applied science policy researchers program officer'},
    {id: 'Economists and economic policy researcher', name: 'Economists and economic policy researcher'},
    {id: 'Business development officer', name: 'Business development officer'},
    {id: 'Marketing researchers', name: 'Marketing researchers'},
    {id: 'Social policy researcher', name: 'Social policy researcher'},
    {id: 'Social policy consultants', name: 'Social policy consultants'},
    {id: 'Social policy program officer', name: 'Social policy program officer'},
    {id: 'Health policy researcher', name: 'Health policy researcher'},
    {id: 'Health policy program officer', name: 'Health policy program officer'},
    {id: 'Education policy researcher', name: 'Education policy researcher'},
    {id: 'Education onsultants', name: 'Education onsultants'},
    {id: 'Sports and fitness policy researcher', name: 'Sports and fitness policy researcher'},
    {id: 'Recreation consultants and program officer', name: 'Recreation consultants and program officer'},
    {id: 'Program officers unique to government', name: 'Program officers unique to government'},
    {id: 'Paralegal', name: 'Paralegal'},
    {id: 'Social and community service worker', name: 'Social and community service worker'},
    {id: 'Early childhood educator and assistant', name: 'Early childhood educator and assistant'},
    {id: 'Instructor of persons with disabilities', name: 'Instructor of persons with disabilities'},
    {id: 'Other religious occupations', name: 'Other religious occupations'},
    {id: 'Police officers (Non-commissioned)', name: 'Police officers (Non-commissioned)'},
    {id: 'Firefighters', name: 'Firefighters'},
    {id: 'Canadian Forces- Commissioned officer', name: 'Canadian Forces- Commissioned officer'},
    {id: 'Home child care providers', name: 'Home child care providers'},
    {id: 'Home support worker and housekeeper', name: 'Home support worker and housekeeper'},
    {id: 'Elementary school teacher assistant', name: 'Elementary school teacher assistant'},
    {id: 'Secondary school teacher assistant', name: 'Secondary school teacher assistant'},
    {id: 'Sheriff', name: 'Sheriff'},
    {id: 'Bailiff', name: 'Bailiff'},
    {id: 'Correctional service officer', name: 'Correctional service officer'},
    {id: 'By-law enforcement officer', name: 'By-law enforcement officer'},
    {id: 'Librarian', name: 'Librarian'},
    {id: 'Conservator and curator', name: 'Conservator and curator'},
    {id: 'Archivist', name: 'Archivist'},
    {id: 'Authors and writer', name: 'Authors and writer'},
    {id: 'Journalist', name: 'Journalist'},
    {id: 'Translator, terminologist and interpreter', name: 'Translator, terminologist and interpreter'},
    {id: 'Producer, director, choreographer', name: 'Producer, director, choreographer'},
    {id: 'Conductor, composer and arranger', name: 'Conductor, composer and arranger'},
    {id: 'Musician and singer', name: 'Musician and singer'},
    {id: 'Dancer', name: 'Dancer'},
    {id: 'Actor and comedian', name: 'Actor and comedian'},
    {id: 'Painters and sculptors artist', name: 'Painters and sculptors artist'},
    {id: 'Library and public archive technician', name: 'Library and public archive technician'},
    {id: 'Technical occupation', name: 'Technical occupation'},
    {id: 'Photographer', name: 'Photographer'},
    {id: 'Film and video camera operator', name: 'Film and video camera operator'},
    {id: 'Graphic art technician', name: 'Graphic art technician'},
    {id: 'Broadcast technicians', name: 'Broadcast technicians'},
    {id: 'Audio and video recording technician', name: 'Audio and video recording technician'},
    {id: 'Motion pictures Professional', name: 'Motion pictures Professional'},
    {id: 'Broadcasting and performing arts professional', name: 'Broadcasting and performing arts professional'},
    {id: 'Support Officer in motion pictures', name: 'Support Officer in motion pictures'},
    {id: 'Broadcasting, photography Officer', name: 'Broadcasting, photography Officer'},
    {id: 'Performing arts Officer', name: 'Performing arts Officer'},
    {id: 'Announcers and other broadcasters', name: 'Announcers and other broadcasters'},
    {id: 'Graphic designers and illustrators', name: 'Graphic designers and illustrators'},
    {id: 'Interior designers and interior decorators', name: 'Interior designers and interior decorators'},
    {id: 'Theatre, fashion, exhibit- designers', name: 'Theatre, fashion, exhibit- designers'},
    {id: 'Artisans and craftspersons', name: 'Artisans and craftspersons'},
    {id: 'Patternmakers - textile, leather,fur products', name: 'Patternmakers - textile, leather,fur products'},
    {id: 'Athletes', name: 'Athletes'},
    {id: 'Coaches', name: 'Coaches'},
    {id: 'Sports officials and referees', name: 'Sports officials and referees'},
    {id: 'Program leaders and instructors in recreation', name: 'Program leaders and instructors in recreation'},
    {id: 'Program leaders and instructors in sport and fitness', name: 'Program leaders and instructors in sport and fitness'},
    {id: 'Retail sales supervisors', name: 'Retail sales supervisors'},
    {id: 'Technical sales specialists - wholesale trade', name: 'Technical sales specialists - wholesale trade'},
    {id: 'Retail and wholesale buyer', name: 'Retail and wholesale buyer'},
    {id: 'Insurance agents and broker', name: 'Insurance agents and broker'},
    {id: 'Real estate agents and salesperson', name: 'Real estate agents and salesperson'},
    {id: 'Financial sales representative', name: 'Financial sales representative'},
    {id: 'Food service supervisor', name: 'Food service supervisor'},
    {id: 'Executive housekeeper', name: 'Executive housekeeper'},
    {id: 'Accommodation supervisor', name: 'Accommodation supervisor'},
    {id: 'Travel and Tourism supervisor', name: 'Travel and Tourism supervisor'},
    {id: 'Customer and information services supervisor', name: 'Customer and information services supervisor'},
    {id: 'Cleaning supervisor', name: 'Cleaning supervisor'},
    {id: 'Other services supervisor', name: 'Other services supervisor'},
    {id: 'Chef', name: 'Chef'},
    {id: 'Cook', name: 'Cook'},
    {id: 'Butchers, meat cutters and fishmongers', name: 'Butchers, meat cutters and fishmongers'},
    {id: 'Baker', name: 'Baker'},
    {id: 'Hairstylist and barber', name: 'Hairstylist and barber'},
    {id: 'Tailors, dressmakers, furriers and milliners', name: 'Tailors, dressmakers, furriers and milliners'},
    {id: 'Shoe repairers and shoemaker', name: 'Shoe repairers and shoemaker'},
    {id: 'Jewellers, jewellery and watch repairer', name: 'Jewellers, jewellery and watch repairer'},
    {id: 'Upholsterer', name: 'Upholsterer'},
    {id: 'Funeral directors and embalmer', name: 'Funeral directors and embalmer'},
    {id: 'Sales and account representative', name: 'Sales and account representative'},
    {id: 'Retail salesperson', name: 'Retail salesperson'},
    //{id: 'Maîtres d'hôtel and hosts/hostesses', name: 'Maîtres d'hôtel and hosts/hostesses'},
    {id: 'Bartender', name: 'Bartender'},
    {id: 'Food and beverage server', name: 'Food and beverage server'},
    {id: 'Travel counsellor', name: 'Travel counsellor'},
    {id: 'Pursers and flight attendant', name: 'Pursers and flight attendant'},
    {id: 'Airline ticket and service agent', name: 'Airline ticket and service agent'},
    {id: 'Ground and water transport ticket agent', name: 'Ground and water transport ticket agent'},
    {id: 'Cargo service representative', name: 'Cargo service representative'},
    {id: 'Hotel front desk clerk', name: 'Hotel front desk clerk'},
    {id: 'Tour and travel guide', name: 'Tour and travel guide'},
    {id: 'Outdoor sport and recreational guide officer', name: 'Outdoor sport and recreational guide officer'},
    {id: 'Casino Agent', name: 'Casino Agent'},
    {id: 'Security guard', name: 'Security guard'},
    {id: 'Customer services representative - financial institutions', name: 'Customer services representative - financial institutions'},
    {id: 'customer and information services representatives', name: 'customer and information services representatives'},
    {id: 'Image, social and other personal consultants', name: 'Image, social and other personal consultants'},
    {id: 'Estheticians, electrologists and related occupations', name: 'Estheticians, electrologists and related occupations'},
    {id: 'Pet groomers and animal care workers', name: 'Pet groomers and animal care workers'},
    {id: 'Cashiers', name: 'Cashiers'},
    {id: 'Service station attendants', name: 'Service station attendants'},
    {id: 'Store shelf stockers, clerks and order fillers', name: 'Store shelf stockers, clerks and order fillers'},
    {id: 'Food counter attendants, kitchen helpers', name: 'Food counter attendants, kitchen helpers'},
    {id: 'Light duty cleaners', name: 'Light duty cleaners'},
    {id: 'Specialized cleaners', name: 'Specialized cleaners'},
    {id: 'Janitors, caretakers and building superintendents', name: 'Janitors, caretakers and building superintendents'},
    {id: 'Dry cleaning, laundry and related occupations', name: 'Dry cleaning, laundry and related occupations'},
    {id: 'Contractors of machining, metal forming, shaping', name: 'Contractors of machining, metal forming, shaping'},
    {id: 'Supervisors of machining, metal forming, shaping', name: 'Supervisors of machining, metal forming, shaping'},
    {id: 'Contractors and supervisors, pipefitting trades', name: 'Contractors and supervisors, pipefitting trades'},
    {id: 'Contractors and supervisors, carpentry trades', name: 'Contractors and supervisors, carpentry trades'},
    {id: 'Machinists, machining and tooling inspectors', name: 'Machinists, machining and tooling inspectors'},
    {id: 'Tool and die makers', name: 'Tool and die makers'},
    {id: 'Sheet metal workers', name: 'Sheet metal workers'},
    {id: 'Boilermakers', name: 'Boilermakers'},
    {id: 'Ironworkers', name: 'Ironworkers'},
    {id: 'Welders and related machine operators', name: 'Welders and related machine operators'},
    {id: 'Electricians', name: 'Electricians'},
    {id: 'Industrial electricians', name: 'Industrial electricians'},
    {id: 'Power system electricians', name: 'Power system electricians'},
    {id: 'Electrical power line and cable workers', name: 'Electrical power line and cable workers'},
    {id: 'Telecommunications line and cable workers', name: 'Telecommunications line and cable workers'},
    {id: 'Telecommunications installation and repair workers', name: 'Telecommunications installation and repair workers'},
    {id: 'Cable television service technicians', name: 'Cable television service technicians'},
    {id: 'Cable service maintenance technicians', name: 'Cable service maintenance technicians'},
    {id: 'Plumbers', name: 'Plumbers'},
    {id: 'Steamfitters', name: 'Steamfitters'},
    {id: 'Pipefitters and sprinkler system installers', name: 'Pipefitters and sprinkler system installers'},
    {id: 'Gas fitters', name: 'Gas fitters'},
    {id: 'Carpenters', name: 'Carpenters'},
    {id: 'Cabinetmakers', name: 'Cabinetmakers'},
    {id: 'Bricklayers', name: 'Bricklayers'},
    {id: 'Concrete finishers', name: 'Concrete finishers'},
    {id: 'Tilesetters', name: 'Tilesetters'},
    {id: 'Plasterers, drywall installers and finishers', name: 'Plasterers, drywall installers and finishers'},
    {id: 'Roofers and shinglers', name: 'Roofers and shinglers'},
    {id: 'Glaziers', name: 'Glaziers'},
    {id: 'Insulators', name: 'Insulators'},
    {id: 'Painters and decorators', name: 'Painters and decorators'},
    {id: 'Floor covering installers', name: 'Floor covering installers'},
    {id: 'Contractors and supervisors, mechanic trades', name: 'Contractors and supervisors, mechanic trades'},
    {id: 'Supervisors, printing and related occupations', name: 'Supervisors, printing and related occupations'},
    {id: 'Supervisors, railway transport operations', name: 'Supervisors, railway transport operations'},
    {id: 'Supervisors- motor transport', name: 'Supervisors- motor transport'},
    {id: 'Supervisors- ground transit operators', name: 'Supervisors- ground transit operators'},
    {id: 'Construction millwrights and industrial mechanics', name: 'Construction millwrights and industrial mechanics'},
    {id: 'Heavy-duty equipment mechanics', name: 'Heavy-duty equipment mechanics'},
    {id: 'Refrigeration and air conditioning mechanics', name: 'Refrigeration and air conditioning mechanics'},
    {id: 'Railway carmen/women', name: 'Railway carmen/women'},
    {id: 'Aircraft mechanics and aircraft inspectors', name: 'Aircraft mechanics and aircraft inspectors'},
    {id: 'Machine fitters', name: 'Machine fitters'},
    {id: 'Elevator constructors and mechanics', name: 'Elevator constructors and mechanics'},
    {id: 'Automotive service technicians', name: 'Automotive service technicians'},
    {id: 'Truck and bus mechanics and mechanical repairers', name: 'Truck and bus mechanics and mechanical repairers'},
    {id: 'Motor vehicle body repairers', name: 'Motor vehicle body repairers'},
    {id: 'Oil and solid fuel heating mechanics', name: 'Oil and solid fuel heating mechanics'},
    {id: 'Appliance servicers and repairers', name: 'Appliance servicers and repairers'},
    {id: 'Electrical mechanics', name: 'Electrical mechanics'},
    {id: 'Motorcycle, all-terrain vehicle mechanics', name: 'Motorcycle, all-terrain vehicle mechanics'},
    {id: 'Small engine and small equipment repairers', name: 'Small engine and small equipment repairers'},
    {id: 'Railway and yard locomotive engineers', name: 'Railway and yard locomotive engineers'},
    {id: 'Railway conductors and brakemen/women', name: 'Railway conductors and brakemen/women'},
    {id: 'Crane operators', name: 'Crane operators'},
    {id: 'Drillers and blasters - surface mining', name: 'Drillers and blasters - surface mining'},
    {id: 'Drillers and blasters - quarrying and construction', name: 'Drillers and blasters - quarrying and construction'},
    {id: 'Water well drillers', name: 'Water well drillers'},
    {id: 'Printing press operators', name: 'Printing press operators'},
    {id: 'Other trades and related occupations', name: 'Other trades and related occupations'},
    {id: 'Residential and commercial installers and servicers', name: 'Residential and commercial installers and servicers'},
    {id: 'Waterworks and gas maintenance workers', name: 'Waterworks and gas maintenance workers'},
    {id: 'Pest controllers and fumigators', name: 'Pest controllers and fumigators'},
    {id: 'Other repairers and servicers', name: 'Other repairers and servicers'},
    {id: 'Longshore workers', name: 'Longshore workers'},
    {id: 'Material handlers', name: 'Material handlers'},
    {id: 'Transport truck drivers', name: 'Transport truck drivers'},
    {id: 'Bus drivers, subway operator', name: 'Bus drivers, subway operator'},
    {id: 'Taxi and limousine drivers and chauffeurs', name: 'Taxi and limousine drivers and chauffeurs'},
    {id: 'Delivery and courier service drivers', name: 'Delivery and courier service drivers'},
    {id: 'Heavy equipment operator', name: 'Heavy equipment operator'},
    {id: 'Public works maintenance equipment operator', name: 'Public works maintenance equipment operator'},
    {id: 'Railway yard and track maintenance workers', name: 'Railway yard and track maintenance workers'},
    {id: 'Water transport deck and engine room crew', name: 'Water transport deck and engine room crew'},
    {id: 'Boat and cable ferry operators', name: 'Boat and cable ferry operators'},
    {id: 'Air transport ramp attendants', name: 'Air transport ramp attendants'},
    {id: 'Construction trades helpers and labourers', name: 'Construction trades helpers and labourers'},
    {id: 'Other trades helpers and labourers', name: 'Other trades helpers and labourers'},
    {id: 'Public works and maintenance labourers', name: 'Public works and maintenance labourers'},
    {id: 'Railway and motor transport labourer', name: 'Railway and motor transport labourer'},
    {id: 'Supervisors, logging and forestry', name: 'Supervisors, logging and forestry'},
    {id: 'Supervisors, mining and quarrying', name: 'Supervisors, mining and quarrying'},
    {id: 'Contractors oil and gas drilling and services', name: 'Contractors oil and gas drilling and services'},
    {id: 'Supervisors, oil and gas drilling and services', name: 'Supervisors, oil and gas drilling and services'},
    {id: 'Underground production and development miners', name: 'Underground production and development miners'},
    {id: 'Oil and gas well drillers, servicers, testers', name: 'Oil and gas well drillers, servicers, testers'},
    {id: 'Logging machinery operators', name: 'Logging machinery operators'},
    {id: 'Agricultural service contractors', name: 'Agricultural service contractors'},
    {id: 'Farm supervisors and specialized livestock workers', name: 'Farm supervisors and specialized livestock workers'},
    {id: 'Contractors and supervisors- landscaping', name: 'Contractors and supervisors- landscaping'},
    {id: 'Contractors and supervisors- grounds maintenance', name: 'Contractors and supervisors- grounds maintenance'},
    {id: 'Contractors and supervisors- horticulture services', name: 'Contractors and supervisors- horticulture services'},
    {id: 'Fishing masters and officers', name: 'Fishing masters and officers'},
    {id: 'Fishermen/women', name: 'Fishermen/women'},
    {id: 'Underground mine service and support workers', name: 'Underground mine service and support workers'},
    {id: 'Oil and gas well drilling', name: 'Oil and gas well drilling'},
    {id: 'Chain saw and skidder operators', name: 'Chain saw and skidder operators'},
    {id: 'Silviculture and forestry workers', name: 'Silviculture and forestry workers'},
    {id: 'General farm workers', name: 'General farm workers'},
    {id: 'Nursery and greenhouse workers', name: 'Nursery and greenhouse workers'},
    {id: 'Fishing vessel deckhands', name: 'Fishing vessel deckhands'},
    {id: 'Trappers and hunters', name: 'Trappers and hunters'},
    {id: 'Harvesting labourers', name: 'Harvesting labourers'},
    {id: 'Landscaping and grounds maintenance labourers', name: 'Landscaping and grounds maintenance labourers'},
    {id: 'Aquaculture and marine harvest labourers', name: 'Aquaculture and marine harvest labourers'},
    {id: 'Mine labourers', name: 'Mine labourers'},
    {id: 'Oil and gas drilling, servicing labourer', name: 'Oil and gas drilling, servicing labourer'},
    {id: 'Logging and forestry labourers', name: 'Logging and forestry labourers'},
    {id: 'Supervisors, mineral and metal processing', name: 'Supervisors, mineral and metal processing'},
    {id: 'Supervisors, petroleum, gas', name: 'Supervisors, petroleum, gas'},
    {id: 'Supervisors, chemical processing and utilities', name: 'Supervisors, chemical processing and utilities'},
    {id: 'Supervisors, food and beverag', name: 'Supervisors, food and beverag'},
    {id: 'Supervisors, plastic products manufacturing', name: 'Supervisors, plastic products manufacturing'},
    {id: 'Supervisors, forest products processing', name: 'Supervisors, forest products processing'},
    {id: 'Supervisors, textile, fabric and fur', name: 'Supervisors, textile, fabric and fur'},
    {id: 'Supervisors, Leather products processing', name: 'Supervisors, Leather products processing'},
    {id: 'Supervisors, motor vehicle assembling', name: 'Supervisors, motor vehicle assembling'},
    {id: 'Supervisors, electronics manufacturing', name: 'Supervisors, electronics manufacturing'},
    {id: 'Supervisors, electrical products manufacturing', name: 'Supervisors, electrical products manufacturing'},
    {id: 'Supervisors, furniture and fixtures manufacturing', name: 'Supervisors, furniture and fixtures manufacturing'},
    {id: 'Supervisors, mechanical products manufacturing', name: 'Supervisors, mechanical products manufacturing'},
    {id: 'Supervisors, metal products manufacturing', name: 'Supervisors, metal products manufacturing'},
    {id: 'Supervisors,products manufacturing and assembly', name: 'Supervisors,products manufacturing and assembly'},
    {id: 'Central control and process operators', name: 'Central control and process operators'},
    {id: 'Mineral and metal processing Professional', name: 'Mineral and metal processing Professional'},
    {id: 'Petroleum, gas and chemical process operators', name: 'Petroleum, gas and chemical process operators'},
    {id: 'Pulping, papermaking and coating control operators', name: 'Pulping, papermaking and coating control operators'},
    {id: 'Power engineers and power systems operators', name: 'Power engineers and power systems operators'},
    {id: 'Water and waste treatment plant operators', name: 'Water and waste treatment plant operators'},
    {id: 'Machine operators, mineral and metal processing', name: 'Machine operators, mineral and metal processing'},
    {id: 'Foundry workers', name: 'Foundry workers'},
    {id: 'Glass forming and finishing machine operators', name: 'Glass forming and finishing machine operators'},
    {id: 'Glass cutters', name: 'Glass cutters'},
    {id: 'Concrete, clay and stone forming operators', name: 'Concrete, clay and stone forming operators'},
    {id: 'Inspectors -mineral and metal processing', name: 'Inspectors -mineral and metal processing'},
    {id: 'Testers, mineral and metal processing', name: 'Testers, mineral and metal processing'},
    {id: 'Metalworking and forging machine operators', name: 'Metalworking and forging machine operators'},
    {id: 'Machining tool operators', name: 'Machining tool operators'},
    {id: 'Other metal products machine operators', name: 'Other metal products machine operators'},
    {id: 'Chemical plant machine operators', name: 'Chemical plant machine operators'},
    {id: 'Plastics processing machine operators', name: 'Plastics processing machine operators'},
    {id: 'Rubber processing machine operators', name: 'Rubber processing machine operators'},
    {id: 'Sawmill machine operators', name: 'Sawmill machine operators'},
    {id: 'Pulp mill machine operators', name: 'Pulp mill machine operators'},
    {id: 'Papermaking and finishing machine operators', name: 'Papermaking and finishing machine operators'},
    {id: 'Other wood processing machine operators', name: 'Other wood processing machine operators'},
    {id: 'Paper converting machine operators', name: 'Paper converting machine operators'},
    {id: 'Woodworking machine operators', name: 'Woodworking machine operators'},
    {id: 'Weavers, knitters', name: 'Weavers, knitters'},
    {id: 'Fabric, fur and leather cutters', name: 'Fabric, fur and leather cutters'},
    {id: 'Industrial sewing machine operators', name: 'Industrial sewing machine operators'},
    {id: 'Fish and seafood plant workers', name: 'Fish and seafood plant workers'},
    {id: 'Graders, food, beverage and products processing', name: 'Graders, food, beverage and products processing'},
    {id: 'Testers food, beverage and products processing', name: 'Testers food, beverage and products processing'},
    {id: 'Plateless printing equipment operators', name: 'Plateless printing equipment operators'},
    {id: 'Camera, platemaking professionals', name: 'Camera, platemaking professionals'},
    {id: 'Binding and finishing machine operators', name: 'Binding and finishing machine operators'},
    {id: 'Photographic and film processors', name: 'Photographic and film processors'},
    {id: 'Aircraft assemblers', name: 'Aircraft assemblers'},
    {id: 'Aircraft assembly inspectors', name: 'Aircraft assembly inspectors'},
    {id: 'Motor vehicle assemblers', name: 'Motor vehicle assemblers'},
    {id: 'Motor vehicle - inspectors and testers', name: 'Motor vehicle - inspectors and testers'},
    {id: 'Electronics assemblers', name: 'Electronics assemblers'},
    {id: 'Electronics inspector and tester', name: 'Electronics inspector and tester'},
    {id: 'Mechanical assemblers and inspectors', name: 'Mechanical assemblers and inspectors'},
    {id: 'Boat assemblers and inspectors', name: 'Boat assemblers and inspectors'},
    {id: 'Furniture and fixture assemblers', name: 'Furniture and fixture assemblers'},
    {id: 'Wood products inspectors', name: 'Wood products inspectors'},
    {id: 'Furniture finishers and refinishers', name: 'Furniture finishers and refinishers'},
    {id: 'Plastic products assemblers', name: 'Plastic products assemblers'},
    {id: 'Plastic products inspectors', name: 'Plastic products inspectors'},
    {id: 'Industrial painters, coaters operators', name: 'Industrial painters, coaters operators'},
    {id: 'Metal finishing process operators', name: 'Metal finishing process operators'},
    {id: 'Labourers in mineral and metal processing', name: 'Labourers in mineral and metal processing'},
    {id: 'Labourers in metal fabrication', name: 'Labourers in metal fabrication'},
    {id: 'Labourers in chemical products processing', name: 'Labourers in chemical products processing'},
    {id: 'Labourers in wood, pulp and paper processing', name: 'Labourers in wood, pulp and paper processing'},
    {id: 'Labourers in plastic products manufacturing', name: 'Labourers in plastic products manufacturing'},
    {id: 'Labourers in textile processing', name: 'Labourers in textile processing'},
    {id: 'Labourers in fish and seafood processing', name: 'Labourers in fish and seafood processing'},
    {id: 'quality assurance manager - cannabis', name: 'quality assurance manager - cannabis'},
    {id: 'cannabis dispensary manager', name: 'cannabis dispensary manager'},
    {id: 'cannabis shop manager', name: 'cannabis shop manager'},
    {id: 'master grower - cannabis', name: 'master grower - cannabis'},
    {id: 'head grower - cannabis', name: 'head grower - cannabis'},
    {id: 'extraction specialist - cannabis', name: 'extraction specialist - cannabis'},
    {id: 'quality control technician - cannabis', name: 'quality control technician - cannabis'},
    {id: 'cloning technician - cannabis', name: 'cloning technician - cannabis'},
    {id: 'cultivation technician', name: 'cultivation technician'},
    {id: 'nurse educator - cannabis', name: 'nurse educator - cannabis'},
    {id: 'budtender - cannabis', name: 'budtender - cannabis'},
    {id: 'bud expert - cannabis', name: 'bud expert - cannabis'},
    {id: 'cannabis educator', name: 'cannabis educator'},
    {id: 'cannabis consultant', name: 'cannabis consultant'},
    {id: 'cannabis courier', name: 'cannabis courier'},
    {id: 'cannabis delivery driver', name: 'cannabis delivery driver'},
    {id: 'section grower - cannabis', name: 'section grower - cannabis'},
    {id: 'lead grower - cannabis', name: 'lead grower - cannabis'},
    {id: 'cannabis trimmer', name: 'cannabis trimmer'},
    {id: 'cannabis trim worker', name: 'cannabis trim worker'},
    {id: 'grower - cannabis', name: 'grower - cannabis'},
    {id: 'production supervisor - cannabis processing', name: 'production supervisor - cannabis processing'},
    {id: 'cannabis processing supervisor', name: 'cannabis processing supervisor'},
    {id: 'encapsulator - cannabis processing', name: 'encapsulator - cannabis processing'},
    {id: 'cannabis processing labourer', name: 'cannabis processing labourer'},
    {id: 'Homemaker', name: 'Homemaker'},
    {id: 'Student -Elementary/Middle School', name: 'Student -Elementary/Middle School'},
    {id: 'Student- High School/Secondary School', name: 'Student- High School/Secondary School'},
    {id: 'Student - College/University', name: 'Student - College/University'},
    {id: 'Child- Early Childhood Education/Day Care 0>5 Years', name: 'Child- Early Childhood Education/Day Care 0>5 Years'},
    {id: 'Disability', name: 'Disability'},
    {id: 'Unemployed', name: 'Unemployed'},
  ],
  ducaPositions: [
    {id: "UNDEFINED", name: "UNDEFINED"},
    {id: "PROFESSIONAL", name: "PROFESSIONAL"},
    {id: "CLERICAL", name: "CLERICAL"},
    {id: "SELF-EMPLOYED", name: "SELF-EMPLOYED"},
    {id: "DOMESTIC ENGINEER", name: "DOMESTIC ENGINEER"},
    {id: "FISHING", name: "FISHING"},
    {id: "AUTO MECHANICS", name: "AUTO MECHANICS"},
    {id: "PRINTING", name: "PRINTING"},
    {id: "ELECTRONICS", name: "ELECTRONICS"},
    {id: "AGRICULTURE", name: "AGRICULTURE"},
    {id: "BUILDERS", name: "BUILDERS"},
    {id: "RETAIL", name: "RETAIL"},
    {id: "WHOLESALE", name: "WHOLESALE"},
    {id: "REAL ESTATE", name: "REAL ESTATE"},
    {id: "ARTISTS", name: "ARTISTS"},
    {id: "LAWYERS", name: "LAWYERS"},
    {id: "TEACHERS", name: "TEACHERS"},
    {id: "COMMUNITY SERVICES", name: "COMMUNITY SERVICES"},
    {id: "HOTEL MANAGEMENT", name: "HOTEL MANAGEMENT"},
    {id: "RETIRED", name: "RETIRED"},
    {id: "FINANCIAL", name: "FINANCIAL"},
    {id: "MEDICAL", name: "MEDICAL"},
    {id: "TECHNICAL", name: "TECHNICAL"},
    {id: "Legislators", name: "Legislators"},
    {id: "Sr Gov't Mgr/Officials", name: "Sr Gov't Mgr/Officials"},
    {id: "Sr Mgr-Fin/Comm/Other", name: "Sr Mgr-Fin/Comm/Other"},
    {id: "Sr Mgr-Health/Educ/Social", name: "Sr Mgr-Health/Educ/Social"},
    {id: "Sr Mgr-Trade/Broadcasting", name: "Sr Mgr-Trade/Broadcasting"},
    {id: "Sr Mgr-Goods Utilities Trans", name: "Sr Mgr-Goods Utilities Trans"},
    {id: "Mgr-Financial", name: "Mgr-Financial"},
    {id: "Mgr-Human Resources", name: "Mgr-Human Resources"},
    {id: "Mgr-Purchasing", name: "Mgr-Purchasing"},
    {id: "Mgr-Other Admin Service", name: "Mgr-Other Admin Service"},
    {id: "Mgr-Ins Real Estate Fin Broker", name: "Mgr-Ins Real Estate Fin Broker"},
    {id: "Mgr-Banking/Credit", name: "Mgr-Banking/Credit"},
    {id: "Mgr-Other Bus. Service", name: "Mgr-Other Bus. Service"},
    {id: "Mgr-TeleComm. Carriers", name: "Mgr-TeleComm. Carriers"},
    {id: "Mgr-Postal/Courier Service", name: "Mgr-Postal/Courier Service"},
    {id: "Mgr-Engineering", name: "Mgr-Engineering"},
    {id: "Mgr-Architecture/Science", name: "Mgr-Architecture/Science"},
    {id: "Mgr-Computer/Info Sys", name: "Mgr-Computer/Info Sys"},
    {id: "Mgr-Health Care", name: "Mgr-Health Care"},
    {id: "Admins-Post-Second/Vocation", name: "Admins-Post-Second/Vocation"},
    {id: "Sch Principals/Admin Elem/Sec", name: "Sch Principals/Admin Elem/Sec"},
    {id: "Mgr-Social Comm/Correctional", name: "Mgr-Social Comm/Correctional"},
    {id: "Mgr-Gov't/ Admin-Health/Soc", name: "Mgr-Gov't/ Admin-Health/Soc"},
    {id: "Mgr-Gov't-Econ Policy", name: "Mgr-Gov't-Econ Policy"},
    {id: "Mgr-Gov't/Admin-Educ Policy", name: "Mgr-Gov't/Admin-Educ Policy"},
    {id: "Mgr-Other Public Admin", name: "Mgr-Other Public Admin"},
    {id: "Mgr-Library/Museum/Art", name: "Mgr-Library/Museum/Art"},
    {id: "Mgr-Broadcasting/Perform Arts", name: "Mgr-Broadcasting/Perform Arts"},
    {id: "Dir-Recreation Sports/Services", name: "Dir-Recreation Sports/Services"},
    {id: "Mgr-Sales/Mrkt/Adver", name: "Mgr-Sales/Mrkt/Adver"},
    {id: "Mgr-Retail Trade", name: "Mgr-Retail Trade"},
    {id: "Mgr-Restaurant/Food Service", name: "Mgr-Restaurant/Food Service"},
    {id: "Mgr-Accommodation Service", name: "Mgr-Accommodation Service"},
    {id: "Officer-Commissioned Police", name: "Officer-Commissioned Police"},
    {id: "Fire Chiefs/Sr Firefight", name: "Fire Chiefs/Sr Firefight"},
    {id: "Officer-Armed Forces", name: "Officer-Armed Forces"},
    {id: "Mgr-Other Service", name: "Mgr-Other Service"},
    {id: "Mgr-Construction", name: "Mgr-Construction"},
    {id: "Residental Home Build/Reno", name: "Residental Home Build/Reno"},
    {id: "Mgr-Transportation", name: "Mgr-Transportation"},
    {id: "Mgr-Facility Oper/Mtce", name: "Mgr-Facility Oper/Mtce"},
    {id: "Mgr-Primary Prod (Except agri)", name: "Mgr-Primary Prod (Except agri)"},
    {id: "Mgr-Manufacturing", name: "Mgr-Manufacturing"},
    {id: "Mgr-Utilities", name: "Mgr-Utilities"},
    {id: "Fin-Auditors/Accountants", name: "Fin-Auditors/Accountants"},
    {id: "Fin-Investment Analysts", name: "Fin-Investment Analysts"},
    {id: "Fin-Investment Dealers/Brokers", name: "Fin-Investment Dealers/Brokers"},
    {id: "Officer-Other Financial", name: "Officer-Other Financial"},
    {id: "Specialists-Human Resources", name: "Specialists-Human Resources"},
    {id: "Supervisors-General Office", name: "Supervisors-General Office"},
    {id: "Supervisors-Finance Insurance", name: "Supervisors-Finance Insurance"},
    {id: "Supervisors-Library/Correspond", name: "Supervisors-Library/Correspond"},
    {id: "Supervisors-Mail/Distribution", name: "Supervisors-Mail/Distribution"},
    {id: "Supervisors-Record/Dist/Sched", name: "Supervisors-Record/Dist/Sched"},
    {id: "Officer-Adminstration", name: "Officer-Adminstration"},
    {id: "Assistant-Executive", name: "Assistant-Executive"},
    {id: "Officer-Personnel/Recruitment", name: "Officer-Personnel/Recruitment"},
    {id: "Administrators-Property", name: "Administrators-Property"},
    {id: "Officer-Purchasing Agent", name: "Officer-Purchasing Agent"},
    {id: "Planners-Conference/Event", name: "Planners-Conference/Event"},
    {id: "Officer-Court/Justices Peace", name: "Officer-Court/Justices Peace"},
    {id: "Officer-Immigration/EI/Reven", name: "Officer-Immigration/EI/Reven"},
    {id: "Bookkeepers", name: "Bookkeepers"},
    {id: "Officer-Loan", name: "Officer-Loan"},
    {id: "Insurance Adjusters/Claims", name: "Insurance Adjusters/Claims"},
    {id: "Insurance Underwriters", name: "Insurance Underwriters"},
    {id: "Assessors/Valuators/Appraisers", name: "Assessors/Valuators/Appraisers"},
    {id: "Customs/Ship/Other Brokers", name: "Customs/Ship/Other Brokers"},
    {id: "Secretaries (Except Legal/Med)", name: "Secretaries (Except Legal/Med)"},
    {id: "Secretaries-Legal", name: "Secretaries-Legal"},
    {id: "Secretaries-Medical", name: "Secretaries-Medical"},
    {id: "Court Recorders/Med Transcript", name: "Court Recorders/Med Transcript"},
    {id: "Clerk-General Office", name: "Clerk-General Office"},
    {id: "Clerk-Records mgmt/Filing", name: "Clerk-Records mgmt/Filing"},
    {id: "Receptionists/Switchboard Oper", name: "Receptionists/Switchboard Oper"},
    {id: "Clerk-Data Entry", name: "Clerk-Data Entry"},
    {id: "Desktop Publish Oper/Related", name: "Desktop Publish Oper/Related"},
    {id: "Operator-Telephone", name: "Operator-Telephone"},
    {id: "Clerk-Accounting/Related", name: "Clerk-Accounting/Related"},
    {id: "Clerk-Payroll", name: "Clerk-Payroll"},
    {id: "Representative-CustomerService", name: "Representative-CustomerService"},
    {id: "Clerk-Banking/Ins/Other Financ", name: "Clerk-Banking/Ins/Other Financ"},
    {id: "Collectors", name: "Collectors"},
    {id: "Clerk-Administrative", name: "Clerk-Administrative"},
    {id: "Clerk-Personnel", name: "Clerk-Personnel"},
    {id: "Clerk-Court", name: "Clerk-Court"},
    {id: "Clerk-Library", name: "Clerk-Library"},
    {id: "Clerk-Correspond/Publication", name: "Clerk-Correspond/Publication"},
    {id: "Clerk-Customer Service/Inform", name: "Clerk-Customer Service/Inform"},
    {id: "Clerk-Survey Interview/Stat", name: "Clerk-Survey Interview/Stat"},
    {id: "Clerk-Mail/Postal/Related", name: "Clerk-Mail/Postal/Related"},
    {id: "Letter Carriers", name: "Letter Carriers"},
    {id: "Courier/Door-to-Door Dist", name: "Courier/Door-to-Door Dist"},
    {id: "Shippers/Receivers", name: "Shippers/Receivers"},
    {id: "Clerk-Storekeepers/Parts", name: "Clerk-Storekeepers/Parts"},
    {id: "Clerk-Production", name: "Clerk-Production"},
    {id: "Clerk-Purchasing/Inventory", name: "Clerk-Purchasing/Inventory"},
    {id: "Operator-Dispatchers/Radio", name: "Operator-Dispatchers/Radio"},
    {id: "Trans Route/Crew Schedulers", name: "Trans Route/Crew Schedulers"},
    {id: "Physicists/Astronomers", name: "Physicists/Astronomers"},
    {id: "Chemists", name: "Chemists"},
    {id: "Geologists/Geochemists", name: "Geologists/Geochemists"},
    {id: "Meteorologists", name: "Meteorologists"},
    {id: "Oth.Prof Occup in Phys Science", name: "Oth.Prof Occup in Phys Science"},
    {id: "Biologists/Related Scientists", name: "Biologists/Related Scientists"},
    {id: "Forestry Professional", name: "Forestry Professional"},
    {id: "Consultant-Agricultural Reps", name: "Consultant-Agricultural Reps"},
    {id: "Engineer-Civil", name: "Engineer-Civil"},
    {id: "Engineer-Mechanical", name: "Engineer-Mechanical"},
    {id: "Engineer-Electrical", name: "Engineer-Electrical"},
    {id: "Engineer-Chemical", name: "Engineer-Chemical"},
    {id: "Engineer-Industrial/Manuf", name: "Engineer-Industrial/Manuf"},
    {id: "Engineer-Meta/Materials", name: "Engineer-Meta/Materials"},
    {id: "Engineer-Mining", name: "Engineer-Mining"},
    {id: "Engineer-Geological", name: "Engineer-Geological"},
    {id: "Engineer-Petroleum", name: "Engineer-Petroleum"},
    {id: "Engineer-Aerospace", name: "Engineer-Aerospace"},
    {id: "Engineer-Computer", name: "Engineer-Computer"},
    {id: "Engineer-Other", name: "Engineer-Other"},
    {id: "Architects", name: "Architects"},
    {id: "Architects-Landscape", name: "Architects-Landscape"},
    {id: "Urban/ Use Planners", name: "Urban/ Use Planners"},
    {id: "Land Surveyors", name: "Land Surveyors"},
    {id: "Math/Statisticians/Actuaries", name: "Math/Statisticians/Actuaries"},
    {id: "Consultant-Information Systems", name: "Consultant-Information Systems"},
    {id: "Analyst-Database/Data Admin", name: "Analyst-Database/Data Admin"},
    {id: "Engineer-Software Designer", name: "Engineer-Software Designer"},
    {id: "Computer Program/Interactive", name: "Computer Program/Interactive"},
    {id: "Designer-Web Developers", name: "Designer-Web Developers"},
    {id: "Technician-Chemical", name: "Technician-Chemical"},
    {id: "Technician-Geo/Mineral", name: "Technician-Geo/Mineral"},
    {id: "Technician-Meteorological", name: "Technician-Meteorological"},
    {id: "Technician-Biological", name: "Technician-Biological"},
    {id: "Inspector-Agri/Fish Products", name: "Inspector-Agri/Fish Products"},
    {id: "Technician-Forestry", name: "Technician-Forestry"},
    {id: "Officer-Conservation/Fishery", name: "Officer-Conservation/Fishery"},
    {id: "Specialists-Landscape/Horticul", name: "Specialists-Landscape/Horticul"},
    {id: "Technician-Civil Engineering", name: "Technician-Civil Engineering"},
    {id: "Technician-Mech Engineering", name: "Technician-Mech Engineering"},
    {id: "Technician-Indus Engineering", name: "Technician-Indus Engineering"},
    {id: "Construction Estimators", name: "Construction Estimators"},
    {id: "Technician-Electrical Engineer", name: "Technician-Electrical Engineer"},
    {id: "Technician-Electronic Service", name: "Technician-Electronic Service"},
    {id: "Technician-Industrial Instrum", name: "Technician-Industrial Instrum"},
    {id: "Technician-Air Instrum/Avion", name: "Technician-Air Instrum/Avion"},
    {id: "Technician-Architectural", name: "Technician-Architectural"},
    {id: "Designer-Industrial", name: "Designer-Industrial"},
    {id: "Technician-Drafting", name: "Technician-Drafting"},
    {id: "Technician-Land Survey", name: "Technician-Land Survey"},
    {id: "Technician-Mapping/Related", name: "Technician-Mapping/Related"},
    {id: "Inspec-Non-Destructive Testers", name: "Inspec-Non-Destructive Testers"},
    {id: "Inspector-Engineering/Regulatr", name: "Inspector-Engineering/Regulatr"},
    {id: "Inspector-Env Health/Safety", name: "Inspector-Env Health/Safety"},
    {id: "Inspector-Construction", name: "Inspector-Construction"},
    {id: "Instructors-Air Pilots", name: "Instructors-Air Pilots"},
    {id: "Air Traffic Control/Related", name: "Air Traffic Control/Related"},
    {id: "Officer-Deck/Water Transport", name: "Officer-Deck/Water Transport"},
    {id: "Officer-Engineer/Water Trans", name: "Officer-Engineer/Water Trans"},
    {id: "Railway/ Marine Traffic Contr", name: "Railway/ Marine Traffic Contr"},
    {id: "Technician-Computer Network", name: "Technician-Computer Network"},
    {id: "Technician-User Support", name: "Technician-User Support"},
    {id: "Technician-Systems Testing", name: "Technician-Systems Testing"},
    {id: "Physician-Specialist", name: "Physician-Specialist"},
    {id: "Physician-General/Family", name: "Physician-General/Family"},
    {id: "Dentists", name: "Dentists"},
    {id: "Veterinarians", name: "Veterinarians"},
    {id: "Optometrists", name: "Optometrists"},
    {id: "Chiropractors", name: "Chiropractors"},
    {id: "Other Health Diagnose/Treating", name: "Other Health Diagnose/Treating"},
    {id: "Pharmacists", name: "Pharmacists"},
    {id: "Dietitians/Nutritionists", name: "Dietitians/Nutritionists"},
    {id: "Audiologists/Speech-Language", name: "Audiologists/Speech-Language"},
    {id: "Physiotherapists", name: "Physiotherapists"},
    {id: "Occup Therapists", name: "Occup Therapists"},
    {id: "Other in Therapy/Assessment", name: "Other in Therapy/Assessment"},
    {id: "Nurses-Head/Supervisor", name: "Nurses-Head/Supervisor"},
    {id: "Nurses-Registered", name: "Nurses-Registered"},
    {id: "Assistant-Medical Lab. Tech", name: "Assistant-Medical Lab. Tech"},
    {id: "Technician-Medical Laboratory", name: "Technician-Medical Laboratory"},
    {id: "Technician-Vet/Animal Health", name: "Technician-Vet/Animal Health"},
    {id: "Respiratory/Perfusion/Cardio", name: "Respiratory/Perfusion/Cardio"},
    {id: "Technologist-Medical Radiation", name: "Technologist-Medical Radiation"},
    {id: "Medical Sonographers", name: "Medical Sonographers"},
    {id: "Technologist-Cardiology", name: "Technologist-Cardiology"},
    {id: "Electroencephalographic/Other", name: "Electroencephalographic/Other"},
    {id: "Technologist-Other Medical", name: "Technologist-Other Medical"},
    {id: "Denturists", name: "Denturists"},
    {id: "Dental Hygienists/Therapists", name: "Dental Hygienists/Therapists"},
    {id: "Technician-Dental/Lab Bench", name: "Technician-Dental/Lab Bench"},
    {id: "Opticians", name: "Opticians"},
    {id: "Midwives/Natural Healing", name: "Midwives/Natural Healing"},
    {id: "Nurses-Licensed Practical", name: "Nurses-Licensed Practical"},
    {id: "Attendant-Ambulance", name: "Attendant-Ambulance"},
    {id: "Other Therapy/Assessment", name: "Other Therapy/Assessment"},
    {id: "Assistant - Dental", name: "Assistant - Dental"},
    {id: "Nurse-Aides/Orderlies", name: "Nurse-Aides/Orderlies"},
    {id: "Health Service-Other Support", name: "Health Service-Other Support"},
    {id: "Judges", name: "Judges"},
    {id: "Lawyers/Quebec Notaries", name: "Lawyers/Quebec Notaries"},
    {id: "University Professors", name: "University Professors"},
    {id: "Teacher-Post-Second/Research", name: "Teacher-Post-Second/Research"},
    {id: "Teacher-College/OtherVocation", name: "Teacher-College/OtherVocation"},
    {id: "Teacher-Secondary Sch", name: "Teacher-Secondary Sch"},
    {id: "Teacher-Elementary Sch/Kinder", name: "Teacher-Elementary Sch/Kinder"},
    {id: "Counsellor-Education", name: "Counsellor-Education"},
    {id: "Psychologists", name: "Psychologists"},
    {id: "Social Workers", name: "Social Workers"},
    {id: "Counsellor-Family/Marriage", name: "Counsellor-Family/Marriage"},
    {id: "Ministers of Religion", name: "Ministers of Religion"},
    {id: "Officer-Probation/Parole", name: "Officer-Probation/Parole"},
    {id: "Consultant-Natural/Applied Sci", name: "Consultant-Natural/Applied Sci"},
    {id: "Analyst-Econ Policy Research", name: "Analyst-Econ Policy Research"},
    {id: "Consultant-Bus. Dev /Marketing", name: "Consultant-Bus. Dev /Marketing"},
    {id: "Consult-Social Policy Research", name: "Consult-Social Policy Research"},
    {id: "Consult-Health Policy Research", name: "Consult-Health Policy Research"},
    {id: "Consult-Educ Policy Research", name: "Consult-Educ Policy Research"},
    {id: "Sports/Recreation/Fitness Prog", name: "Sports/Recreation/Fitness Prog"},
    {id: "Officer-Prog Unique to Gov't", name: "Officer-Prog Unique to Gov't"},
    {id: "Social Science-Other", name: "Social Science-Other"},
    {id: "Paralegal/Related Occupation", name: "Paralegal/Related Occupation"},
    {id: "Community/Social Service", name: "Community/Social Service"},
    {id: "Counsellors-Employment", name: "Counsellors-Employment"},
    {id: "Teacher-Early Childhood/Asst", name: "Teacher-Early Childhood/Asst"},
    {id: "Instructors-Per with Disabled", name: "Instructors-Per with Disabled"},
    {id: "Instructors-Other", name: "Instructors-Other"},
    {id: "Religious-Other", name: "Religious-Other"},
    {id: "Librarians", name: "Librarians"},
    {id: "Conservators/Curators", name: "Conservators/Curators"},
    {id: "Archivists", name: "Archivists"},
    {id: "Authors/Writers", name: "Authors/Writers"},
    {id: "Editors", name: "Editors"},
    {id: "Journalists", name: "Journalists"},
    {id: "Public Relations/Communication", name: "Public Relations/Communication"},
    {id: "Translators/Interpreters", name: "Translators/Interpreters"},
    {id: "Producers/Directors/Choreograp", name: "Producers/Directors/Choreograp"},
    {id: "Conductors/Composers", name: "Conductors/Composers"},
    {id: "Musicians/Singers", name: "Musicians/Singers"},
    {id: "Dancers", name: "Dancers"},
    {id: "Actors/Comedians", name: "Actors/Comedians"},
    {id: "Painters/Sculptors/Other", name: "Painters/Sculptors/Other"},
    {id: "Assistant-Library/Archive Tech", name: "Assistant-Library/Archive Tech"},
    {id: "Museums/Art Galleries-Other", name: "Museums/Art Galleries-Other"},
    {id: "Photographers", name: "Photographers"},
    {id: "Operator-Film/Video Camera", name: "Operator-Film/Video Camera"},
    {id: "Technician-Graphic Arts", name: "Technician-Graphic Arts"},
    {id: "Technician-Broadcast", name: "Technician-Broadcast"},
    {id: "Technician-Audio/Video Record", name: "Technician-Audio/Video Record"},
    {id: "Motion Pic/Broadcast/Perf Arts", name: "Motion Pic/Broadcast/Perf Arts"},
    {id: "Mgr Motion Pic/Broad/Perf Arts", name: "Mgr Motion Pic/Broad/Perf Arts"},
    {id: "Announcers/Other Broadcasters", name: "Announcers/Other Broadcasters"},
    {id: "Performers-Other", name: "Performers-Other"},
    {id: "Designer-Graphic/Illustrators", name: "Designer-Graphic/Illustrators"},
    {id: "Designer-Interior", name: "Designer-Interior"},
    {id: "Designer-Theatre/Fashion", name: "Designer-Theatre/Fashion"},
    {id: "Artisans/Craftspersons", name: "Artisans/Craftspersons"},
    {id: "Patternmaker-Textile/Leather", name: "Patternmaker-Textile/Leather"},
    {id: "Athletes", name: "Athletes"},
    {id: "Coaches", name: "Coaches"},
    {id: "Officials- Sports/Referees", name: "Officials- Sports/Referees"},
    {id: "Instruct Recreat/Sport/Fitness", name: "Instruct Recreat/Sport/Fitness"},
    {id: "Mgr-Food Service", name: "Mgr-Food Service"},
    {id: "Executive Housekeepers", name: "Executive Housekeepers"},
    {id: "Mgr-Dry Cleaning/Laundry", name: "Mgr-Dry Cleaning/Laundry"},
    {id: "Mgr-Cleaning Supervisor", name: "Mgr-Cleaning Supervisor"},
    {id: "Mgr-Other Service Supervisor", name: "Mgr-Other Service Supervisor"},
    {id: "Technical Sales Specialists", name: "Technical Sales Specialists"},
    {id: "Agent-Insurance/Brokers", name: "Agent-Insurance/Brokers"},
    {id: "Agent-Real Estate/Salespersons", name: "Agent-Real Estate/Salespersons"},
    {id: "Buyer Retail/Wholesale", name: "Buyer Retail/Wholesale"},
    {id: "Operator-Grain Elevator", name: "Operator-Grain Elevator"},
    {id: "Chefs", name: "Chefs"},
    {id: "Cooks", name: "Cooks"},
    {id: "Butchers/Meat Cutters/Fish", name: "Butchers/Meat Cutters/Fish"},
    {id: "Bakers", name: "Bakers"},
    {id: "Officer-Police", name: "Officer-Police"},
    {id: "Firefighters", name: "Firefighters"},
    {id: "Hairstylists/Barbers", name: "Hairstylists/Barbers"},
    {id: "Funeral Directors/Embalmers", name: "Funeral Directors/Embalmers"},
    {id: "Sales Reps-Wholesale Trade", name: "Sales Reps-Wholesale Trade"},
    {id: "Retail Salespersons/SalesClerk", name: "Retail Salespersons/SalesClerk"},
    {id: "Counsellors-Travel", name: "Counsellors-Travel"},
    {id: "Attendant-Pursers/Flight", name: "Attendant-Pursers/Flight"},
    {id: "Agent-Airline Sales/Service", name: "Agent-Airline Sales/Service"},
    {id: "Agent-Ticket/Cargo Servic Reps", name: "Agent-Ticket/Cargo Servic Reps"},
    {id: "Clerk-Hotel Front Desk", name: "Clerk-Hotel Front Desk"},
    {id: "Guides-Tour/Travel", name: "Guides-Tour/Travel"},
    {id: "Guides-OutdoorSport/Recreation", name: "Guides-OutdoorSport/Recreation"},
    {id: "Attendent-Casino", name: "Attendent-Casino"},
    {id: "Maîtres d'hôtel/Hosts/Hostesse", name: "Maîtres d'hôtel/Hosts/Hostesse"},
    {id: "Bartenders", name: "Bartenders"},
    {id: "Food/Beverage Servers", name: "Food/Beverage Servers"},
    {id: "Sheriffs/Bailiffs", name: "Sheriffs/Bailiffs"},
    {id: "Officer-Correctional Service", name: "Officer-Correctional Service"},
    {id: "Officer-By-Law Enforce/Other", name: "Officer-By-Law Enforce/Other"},
    {id: "Armed Forces-Occup Unique", name: "Armed Forces-Occup Unique"},
    {id: "Officer-Other Protective", name: "Officer-Other Protective"},
    {id: "Visiting Homemakers/Housekeep", name: "Visiting Homemakers/Housekeep"},
    {id: "Assistant-Elem/Second School", name: "Assistant-Elem/Second School"},
    {id: "Babysitters/Nannies", name: "Babysitters/Nannies"},
    {id: "Consult-Image/Social/Other", name: "Consult-Image/Social/Other"},
    {id: "Estheticians/Electrologists", name: "Estheticians/Electrologists"},
    {id: "Pet Groomers/Animal Care", name: "Pet Groomers/Animal Care"},
    {id: "Other Personal Service", name: "Other Personal Service"},
    {id: "Cashiers", name: "Cashiers"},
    {id: "Attendant-Service Station", name: "Attendant-Service Station"},
    {id: "Clerk-Grocery/Store Stockers", name: "Clerk-Grocery/Store Stockers"},
    {id: "Other Elemental Sales Occup", name: "Other Elemental Sales Occup"},
    {id: "Food Counter Attend/Kitchen", name: "Food Counter Attend/Kitchen"},
    {id: "Guard-Security/Related Occup", name: "Guard-Security/Related Occup"},
    {id: "Cleaner-Light Duty", name: "Cleaner-Light Duty"},
    {id: "Cleaner-Specialized", name: "Cleaner-Specialized"},
    {id: "Janitors/Caretakers", name: "Janitors/Caretakers"},
    {id: "Oper-Amusemnt/Recreation/Sport", name: "Oper-Amusemnt/Recreation/Sport"},
    {id: "Attendant-Accommodation/Travel", name: "Attendant-Accommodation/Travel"},
    {id: "Dry Cleaning/Laundry Occup", name: "Dry Cleaning/Laundry Occup"},
    {id: "Ironing/Pressing/Finishing Occ", name: "Ironing/Pressing/Finishing Occ"},
    {id: "Other Elemental Service", name: "Other Elemental Service"},
    {id: "Mgr/Machinists/Related Occup", name: "Mgr/Machinists/Related Occup"},
    {id: "Contractor-Mgr/Elec Trades", name: "Contractor-Mgr/Elec Trades"},
    {id: "Contractor-Mgr/Pipefitting", name: "Contractor-Mgr/Pipefitting"},
    {id: "Contractor-Mgr/Metal Forming", name: "Contractor-Mgr/Metal Forming"},
    {id: "Contractor-Mgr/Carpentry", name: "Contractor-Mgr/Carpentry"},
    {id: "Contractor-Mgr/Mechanic", name: "Contractor-Mgr/Mechanic"},
    {id: "Contractors/Mgr/Heavy Const", name: "Contractors/Mgr/Heavy Const"},
    {id: "Mgr-Printing/Related", name: "Mgr-Printing/Related"},
    {id: "Contractor-Mgr/Other Const", name: "Contractor-Mgr/Other Const"},
    {id: "Mgr-Railway Transport Operatn", name: "Mgr-Railway Transport Operatn"},
    {id: "Mgr-Motor/Ground Transit Oper", name: "Mgr-Motor/Ground Transit Oper"},
    {id: "Inspector-Machinists/Tooling", name: "Inspector-Machinists/Tooling"},
    {id: "Tool/Die Makers", name: "Tool/Die Makers"},
    {id: "Electrician", name: "Electrician"},
    {id: "Electricians-Industrial", name: "Electricians-Industrial"},
    {id: "Electrician-Power System", name: "Electrician-Power System"},
    {id: "Elec Power Line/Cable Workers", name: "Elec Power Line/Cable Workers"},
    {id: "TeleComm Line/Cable Workers", name: "TeleComm Line/Cable Workers"},
    {id: "TeleComm Install/Repair Worker", name: "TeleComm Install/Repair Worker"},
    {id: "Cable Television Svc/Mtce Tech", name: "Cable Television Svc/Mtce Tech"},
    {id: "Plumbers", name: "Plumbers"},
    {id: "Steam/Pipe fit /Sprinkler Inst", name: "Steam/Pipe fit /Sprinkler Inst"},
    {id: "Gas Fitters", name: "Gas Fitters"},
    {id: "Sheet Metal Workers", name: "Sheet Metal Workers"},
    {id: "Boilermakers", name: "Boilermakers"},
    {id: "Struct Metal/Platework Fabric", name: "Struct Metal/Platework Fabric"},
    {id: "Ironworkers", name: "Ironworkers"},
    {id: "Operator-Welders/Related Mach", name: "Operator-Welders/Related Mach"},
    {id: "Blacksmiths/Die Setters", name: "Blacksmiths/Die Setters"},
    {id: "Carpenters", name: "Carpenters"},
    {id: "Cabinetmakers", name: "Cabinetmakers"},
    {id: "Bricklayers", name: "Bricklayers"},
    {id: "Concrete Finishers", name: "Concrete Finishers"},
    {id: "Tilesetters", name: "Tilesetters"},
    {id: "Plasterers/Drywall/Finishers", name: "Plasterers/Drywall/Finishers"},
    {id: "Roofers/Shinglers", name: "Roofers/Shinglers"},
    {id: "Glaziers", name: "Glaziers"},
    {id: "Insulators", name: "Insulators"},
    {id: "Painters/Decorators", name: "Painters/Decorators"},
    {id: "Floor Covering Installer", name: "Floor Covering Installer"},
    {id: "Construct Millwrights/Industri", name: "Construct Millwrights/Industri"},
    {id: "Heavy-Duty equip mech", name: "Heavy-Duty equip mech"},
    {id: "Refrig/Air Conditioning mech", name: "Refrig/Air Conditioning mech"},
    {id: "Railway Carmen/women", name: "Railway Carmen/women"},
    {id: "Aircraft mech/ Inspectors", name: "Aircraft mech/ Inspectors"},
    {id: "Machine Fitters", name: "Machine Fitters"},
    {id: "Textile Machinery mech/Repair", name: "Textile Machinery mech/Repair"},
    {id: "Elevator Constructors/mech", name: "Elevator Constructors/mech"},
    {id: "Mechanice-Auto Truck Bus", name: "Mechanice-Auto Truck Bus"},
    {id: "Motor Vehicle Body Repairers", name: "Motor Vehicle Body Repairers"},
    {id: "Oil/Solid Fuel Heating mechanc", name: "Oil/Solid Fuel Heating mechanc"},
    {id: "Elec Appliance Svcrs/Repairer", name: "Elec Appliance Svcrs/Repairer"},
    {id: "Mechanic-Electrical", name: "Mechanic-Electrical"},
    {id: "Mechanic-Motorcycle/Other", name: "Mechanic-Motorcycle/Other"},
    {id: "Mechanic-Small Engine/equip", name: "Mechanic-Small Engine/equip"},
    {id: "Upholsterers", name: "Upholsterers"},
    {id: "Tailors/Dressmakers/Furrier", name: "Tailors/Dressmakers/Furrier"},
    {id: "Shoe Repairers/Shoemakers", name: "Shoe Repairers/Shoemakers"},
    {id: "Jewellers/Watch Repairers", name: "Jewellers/Watch Repairers"},
    {id: "Engineer-Stationary/ Operator", name: "Engineer-Stationary/ Operator"},
    {id: "Operator-Power Systems/Stat", name: "Operator-Power Systems/Stat"},
    {id: "Engineer-Railway/Yard Train", name: "Engineer-Railway/Yard Train"},
    {id: "Railway Conductors/Brakemen", name: "Railway Conductors/Brakemen"},
    {id: "Operator-Crane", name: "Operator-Crane"},
    {id: "Drillers/Blast/Mine/Quarry", name: "Drillers/Blast/Mine/Quarry"},
    {id: "Water Well Drillers", name: "Water Well Drillers"},
    {id: "Operator-Printing Press", name: "Operator-Printing Press"},
    {id: "Commercial Divers", name: "Commercial Divers"},
    {id: "Other Trades/Related Occup", name: "Other Trades/Related Occup"},
    {id: "Truck Drivers", name: "Truck Drivers"},
    {id: "Bus/Subway/Other Transit", name: "Bus/Subway/Other Transit"},
    {id: "Taxi/Limousine Drivers/Chauff", name: "Taxi/Limousine Drivers/Chauff"},
    {id: "Delivery/Courier Svc Drivers", name: "Delivery/Courier Svc Drivers"},
    {id: "Operator-Heavy equipment", name: "Operator-Heavy equipment"},
    {id: "Oper-Public Works Mtce equip", name: "Oper-Public Works Mtce equip"},
    {id: "Railway Yard Workers", name: "Railway Yard Workers"},
    {id: "Railway Track Mtce Workers", name: "Railway Track Mtce Workers"},
    {id: "Deck Crew/Water Transport", name: "Deck Crew/Water Transport"},
    {id: "Engine Room Crew/Water Trans", name: "Engine Room Crew/Water Trans"},
    {id: "Operator-Lock/Cable Ferry", name: "Operator-Lock/Cable Ferry"},
    {id: "Operator-Boat", name: "Operator-Boat"},
    {id: "Attendant-Air Transport Ramp", name: "Attendant-Air Transport Ramp"},
    {id: "Res/Comm Installers/Servicer", name: "Res/Comm Installers/Servicer"},
    {id: "Waterworks/Gas Mtce Workers", name: "Waterworks/Gas Mtce Workers"},
    {id: "Auto Mech Installers/Servicer", name: "Auto Mech Installers/Servicer"},
    {id: "Pest Controllers/Fumigators", name: "Pest Controllers/Fumigators"},
    {id: "Other Repairers/Servicer", name: "Other Repairers/Servicer"},
    {id: "Longshore Workers", name: "Longshore Workers"},
    {id: "Material Handler", name: "Material Handler"},
    {id: "Construct Trades Labourers", name: "Construct Trades Labourers"},
    {id: "Other Trades Helpers/Labourers", name: "Other Trades Helpers/Labourers"},
    {id: "Public Works/Mtce Labourers", name: "Public Works/Mtce Labourers"},
    {id: "Railway/Motor Transport Labour", name: "Railway/Motor Transport Labour"},
    {id: "Mgr-Logging/Forestry", name: "Mgr-Logging/Forestry"},
    {id: "Mgr-Mining/Quarrying", name: "Mgr-Mining/Quarrying"},
    {id: "Mgr-Oil/Gas Drilling/Service", name: "Mgr-Oil/Gas Drilling/Service"},
    {id: "Development Miners", name: "Development Miners"},
    {id: "Oil/Gas Well Drillers/Service", name: "Oil/Gas Well Drillers/Service"},
    {id: "Operator-Logging Machinery", name: "Operator-Logging Machinery"},
    {id: "Farmers/Farm Manager", name: "Farmers/Farm Manager"},
    {id: "Agricultural/Related Service", name: "Agricultural/Related Service"},
    {id: "Farm Mgr/Livestock Workers", name: "Farm Mgr/Livestock Workers"},
    {id: "Operator-Nursery/Greenhouse", name: "Operator-Nursery/Greenhouse"},
    {id: "Landscaping/Grounds Mtce", name: "Landscaping/Grounds Mtce"},
    {id: "Mgr-Landscape/Horticulture", name: "Mgr-Landscape/Horticulture"},
    {id: "Mgr-Aquaculture Operator", name: "Mgr-Aquaculture Operator"},
    {id: "Officer-Fishing Masters", name: "Officer-Fishing Masters"},
    {id: "Fishing Vessel Skippers/Fisher", name: "Fishing Vessel Skippers/Fisher"},
    {id: "Underground Mine Workers", name: "Underground Mine Workers"},
    {id: "Oil/Gas Well Drilling Worker", name: "Oil/Gas Well Drilling Worker"},
    {id: "Operator-Chain Saw/Skidder", name: "Operator-Chain Saw/Skidder"},
    {id: "Silviculture/Forestry Workers", name: "Silviculture/Forestry Workers"},
    {id: "Gen Farm Workers", name: "Gen Farm Workers"},
    {id: "Nursery/Greenhouse Workers", name: "Nursery/Greenhouse Workers"},
    {id: "Fishing Vessel Deckhand", name: "Fishing Vessel Deckhand"},
    {id: "Trappers/Hunters", name: "Trappers/Hunters"},
    {id: "Harvesting Labourers", name: "Harvesting Labourers"},
    {id: "Aquaculture/Marine Harvest", name: "Aquaculture/Marine Harvest"},
    {id: "Mine Labourers", name: "Mine Labourers"},
    {id: "Oil/Gas Drilling/Servicing", name: "Oil/Gas Drilling/Servicing"},
    {id: "Logging/Forestry Labourers", name: "Logging/Forestry Labourers"},
    {id: "Mgr-Mineral/Metal Processing", name: "Mgr-Mineral/Metal Processing"},
    {id: "Mgr-Petro/Gas/Chemical Process", name: "Mgr-Petro/Gas/Chemical Process"},
    {id: "Mgr-Food/Bev/Tobacco Process", name: "Mgr-Food/Bev/Tobacco Process"},
    {id: "Mgr-Plastic/Rubber Products", name: "Mgr-Plastic/Rubber Products"},
    {id: "Mgr-Forest Products Process", name: "Mgr-Forest Products Process"},
    {id: "Mgr-Textile Processing", name: "Mgr-Textile Processing"},
    {id: "Mgr-Motor Vehicle Assembling", name: "Mgr-Motor Vehicle Assembling"},
    {id: "Mgr-Electronics Manufacture", name: "Mgr-Electronics Manufacture"},
    {id: "Mgr-Elec Products Manufacture", name: "Mgr-Elec Products Manufacture"},
    {id: "Mgr-Furniture/Fixtures", name: "Mgr-Furniture/Fixtures"},
    {id: "Mgr-Fabric/Fur/Leather", name: "Mgr-Fabric/Fur/Leather"},
    {id: "Mgr-Other Mech/Metal", name: "Mgr-Other Mech/Metal"},
    {id: "Mgr-Other Products Manufactr", name: "Mgr-Other Products Manufactr"},
    {id: "Mineral/Metal Process Manfuctr", name: "Mineral/Metal Process Manfuctr"},
    {id: "Operator-Petroleum/Gas/Chemicl", name: "Operator-Petroleum/Gas/Chemicl"},
    {id: "Operator-Pulping Control", name: "Operator-Pulping Control"},
    {id: "Operator-Papermaking/Coating", name: "Operator-Papermaking/Coating"},
    {id: "Mach Oper/Mineral/Metal Proces", name: "Mach Oper/Mineral/Metal Proces"},
    {id: "Foundry Workers", name: "Foundry Workers"},
    {id: "Oper-Glass Forming/Finishing", name: "Oper-Glass Forming/Finishing"},
    {id: "Concrete/Clay/Stone Forming Op", name: "Concrete/Clay/Stone Forming Op"},
    {id: "Testers/Mineral/Metal Process", name: "Testers/Mineral/Metal Process"},
    {id: "Operator-Chemical Plant Mach", name: "Operator-Chemical Plant Mach"},
    {id: "Operator-Plastics Process Mach", name: "Operator-Plastics Process Mach"},
    {id: "Operator-Rubber Process Mach", name: "Operator-Rubber Process Mach"},
    {id: "Operator-Water/Waste Plant", name: "Operator-Water/Waste Plant"},
    {id: "Operator-Sawmill Machine", name: "Operator-Sawmill Machine"},
    {id: "Operator-Pulp Mill Machine", name: "Operator-Pulp Mill Machine"},
    {id: "Operator-Papermake/Finish Mach", name: "Operator-Papermake/Finish Mach"},
    {id: "Operator-Wood Process Other", name: "Operator-Wood Process Other"},
    {id: "Other-Paper Converting Mach", name: "Other-Paper Converting Mach"},
    {id: "Lumber Graders/Other Wood", name: "Lumber Graders/Other Wood"},
    {id: "Oper-Textile Fibre/Yarn Prep", name: "Oper-Textile Fibre/Yarn Prep"},
    {id: "Weavers/Knitters/Other Fabric", name: "Weavers/Knitters/Other Fabric"},
    {id: "Oper-Textile Dyeing/Finishing", name: "Oper-Textile Dyeing/Finishing"},
    {id: "Textile /Graders/Samplers", name: "Textile /Graders/Samplers"},
    {id: "Operator-Sewing Machine", name: "Operator-Sewing Machine"},
    {id: "Fabric/Fur/Leather Cutters", name: "Fabric/Fur/Leather Cutters"},
    {id: "Hide/Pelt Processing Workers", name: "Hide/Pelt Processing Workers"},
    {id: "Testers/Fabric/Fur/Leather", name: "Testers/Fabric/Fur/Leather"},
    {id: "MachOper/Food/Beverage Process", name: "MachOper/Food/Beverage Process"},
    {id: "Butchers/Meat Cutters/Poultry", name: "Butchers/Meat Cutters/Poultry"},
    {id: "Fish Plant Workers", name: "Fish Plant Workers"},
    {id: "Tobacco Processing Mach Oper", name: "Tobacco Processing Mach Oper"},
    {id: "Testers/Graders/Food/Bev Proc", name: "Testers/Graders/Food/Bev Proc"},
    {id: "Operator-Printing Machine", name: "Operator-Printing Machine"},
    {id: "Camera/Platemaking Prepress", name: "Camera/Platemaking Prepress"},
    {id: "Oper-Binding/Finishing Machine", name: "Oper-Binding/Finishing Machine"},
    {id: "Photographic/Film Processors", name: "Photographic/Film Processors"},
    {id: "Inspector-Aircraft Assemblers", name: "Inspector-Aircraft Assemblers"},
    {id: "Inspector-Motor Vehicle Assemb", name: "Inspector-Motor Vehicle Assemb"},
    {id: "Electros Assembler/fabricators", name: "Electros Assembler/fabricators"},
    {id: "Inspector-Elec Appliance Manfc", name: "Inspector-Elec Appliance Manfc"},
    {id: "Industrial Elec Motors Assem", name: "Industrial Elec Motors Assem"},
    {id: "Inspector-Mechanic Assemblers", name: "Inspector-Mechanic Assemblers"},
    {id: "Mach Oper/Elec Apparatus", name: "Mach Oper/Elec Apparatus"},
    {id: "Inspector-Boat Assemblers", name: "Inspector-Boat Assemblers"},
    {id: "Furniture/Fixture Assemblers", name: "Furniture/Fixture Assemblers"},
    {id: "Other Wood Products Assemblers", name: "Other Wood Products Assemblers"},
    {id: "Furniture Finishers/Refinisher", name: "Furniture Finishers/Refinisher"},
    {id: "Plastic Prods Assemble/Finish", name: "Plastic Prods Assemble/Finish"},
    {id: "Painters/Coaters-Industrial", name: "Painters/Coaters-Industrial"},
    {id: "Plating/Metal Spraying", name: "Plating/Metal Spraying"},
    {id: "Inspector-Other Assemblers", name: "Inspector-Other Assemblers"},
    {id: "Operator-Machining Tool", name: "Operator-Machining Tool"},
    {id: "Operator-Forging Machine", name: "Operator-Forging Machine"},
    {id: "Operator-Woodworking Machine", name: "Operator-Woodworking Machine"},
    {id: "Operator-Metalworking Machine", name: "Operator-Metalworking Machine"},
    {id: "Mach Oper-Other Metal Products", name: "Mach Oper-Other Metal Products"},
    {id: "Mach Oper-Other Product", name: "Mach Oper-Other Product"},
    {id: "Labourers Mineral/Metal Proces", name: "Labourers Mineral/Metal Proces"},
    {id: "Labourers in Metal Fabrication", name: "Labourers in Metal Fabrication"},
    {id: "Labourers Chemical Process", name: "Labourers Chemical Process"},
    {id: "LabourerWood/Pulp/Paper Proces", name: "LabourerWood/Pulp/Paper Proces"},
    {id: "Labourer Rubber/Plastic Prod", name: "Labourer Rubber/Plastic Prod"},
    {id: "Labourer Textile Processing", name: "Labourer Textile Processing"},
    {id: "Labourer Food/Beverage/Tobacco", name: "Labourer Food/Beverage/Tobacco"},
    {id: "Labourer in Fish Processing", name: "Labourer in Fish Processing"},
    {id: "Labourer-Other Process/Manu", name: "Labourer-Other Process/Manu"},
    {id: "Student", name: "Student"},
    {id: "Aboriginal Affairs", name: "Aboriginal Affairs"},
    {id: "Child under 18", name: "Child under 18"},
    {id: "Deceased", name: "Deceased"},
    {id: "Unemployed", name: "Unemployed"},
    {id: "Stay at home parent", name: "Stay at home parent"},
  ],
}
